(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(96770);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ Button_Button; },
  "Z": function() { return /* reexport */ components_Button_Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./components/Button/Button.module.scss
var Button_module = __webpack_require__(85474);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./components/Button/Button.tsx




// TODO: spread the default props so they can actually be used when using this button - problems with some HTML button props messing with mui button props
var Button_Button = function(param) {
    var children = param.children, onClick = param.onClick, _href = param.href, href = _href === void 0 ? "" : _href, disabled = param.disabled, trackFunction = param.trackFunction, iconLeft = param.iconLeft, iconRight = param.iconRight, className = param.className, _type = param.type, type = _type === void 0 ? "button" : _type, _variant = param.variant, variant = _variant === void 0 ? "contained" : _variant, _colorVariant = param.colorVariant, colorVariant = _colorVariant === void 0 ? "primary" : _colorVariant;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((Button_module_default()).container, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            className: (0,clsx_m/* default */.Z)((Button_module_default()).myButton, variant === "contained" ? (Button_module_default()).contained : (Button_module_default()).outlined, colorVariant === "secondary" && (Button_module_default()).secondary),
            variant: variant,
            href: href,
            type: type,
            disabled: disabled,
            onClick: function() {
                if (disabled) {
                    return;
                }
                var ref;
                trackFunction === null || trackFunction === void 0 ? void 0 : trackFunction({
                    "element text": (ref = children === null || children === void 0 ? void 0 : children.toString()) !== null && ref !== void 0 ? ref : "",
                    "element type": "button"
                });
                onClick === null || onClick === void 0 ? void 0 : onClick();
            },
            startIcon: iconLeft,
            endIcon: iconRight,
            children: children
        })
    });
};
/* harmony default export */ var components_Button_Button = (Button_Button);

;// CONCATENATED MODULE: ./components/Button/index.ts



/***/ }),

/***/ 82898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* reexport */ ProfileBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./modules/LandingHeaderV2/hooks/useUserDisplayInfo.ts
var useUserDisplayInfo = __webpack_require__(43707);
// EXTERNAL MODULE: ./utils/appClientConfig.ts
var appClientConfig = __webpack_require__(77469);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
;// CONCATENATED MODULE: ./assets/profileBannerDoctor.png
/* harmony default export */ var profileBannerDoctor = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/profileBannerDoctor.45cf171f.png","height":404,"width":410,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAY1BMVEVMaXESNl+ARiqlbVoEP6N/kLuXteoqVI1jRzqEd4WKXVMGTb89W5hNVHoDWNyqoKpsiL69qafZuKombd2DrvXBtsJxc4uLa2KHcnoXVbi3dE6VVjNja4sDUs6Mi6XE1Pdjl+twEBImAAAAFnRSTlMAGrrsaPz+DGW+08L4/P3++/z+/fBEyeUPCgAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAEFJREFUCJljYAABFhZ2MM0kLskNotmZpXhkQTQjlzQvHwMDA4cYq4S4MAMDA6cEGxu/AoghxiokLwKSkhGQExQFAESVAoQENAWMAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-cookie-consent/build/index.js
var build = __webpack_require__(92491);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./components/ProfileBanner/ProfileBanner.module.scss
var ProfileBanner_module = __webpack_require__(38948);
var ProfileBanner_module_default = /*#__PURE__*/__webpack_require__.n(ProfileBanner_module);
;// CONCATENATED MODULE: ./components/ProfileBanner/ProfileBanner.tsx














var ProfileBanner = function(param) {
    var cookieConsentOverwrite = param.cookieConsentOverwrite;
    var ref = (0,react.useState)(false), closed = ref[0], setClosed = ref[1];
    var isDesktop = (0,useMediaQuery/* default */.Z)("(min-width: 768px)");
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var isUserLoggedIn = (0,useUserDisplayInfo/* useUserDisplayInfo */.l)().isUserLoggedIn;
    var _practitionerProfileUrl;
    var profileUrl = (_practitionerProfileUrl = appClientConfig/* appClientConfig.practitionerProfileUrl */.p.practitionerProfileUrl) !== null && _practitionerProfileUrl !== void 0 ? _practitionerProfileUrl : "";
    var consent = cookieConsentOverwrite !== null && cookieConsentOverwrite !== void 0 ? cookieConsentOverwrite : (0,build.getCookieConsentValue)();
    if (consent !== "true" || isUserLoggedIn) {
        return null;
    }
    var VariablePill = function() {
        return isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Top rates,"
                }),
                " negotiated for you"
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Competitive rates"
        });
    };
    var onBannerClose = function() {
        setClosed(true);
        track("Click", {
            action: "Close profile banner",
            "element text": "",
            "element type": "button"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((ProfileBanner_module_default()).bannerContainer, closed && (ProfileBanner_module_default()).closed),
        role: "banner",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProfileBanner_module_default()).imageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: profileBannerDoctor,
                    priority: true,
                    alt: "",
                    "aria-hidden": true,
                    width: 200,
                    height: 200
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (ProfileBanner_module_default()).header,
                        children: "Finding your next job just got easier."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (ProfileBanner_module_default()).subHeader,
                        children: "Register to access"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: (ProfileBanner_module_default()).benefitsPillsList,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Exclusive"
                                    }),
                                    " roles"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VariablePill, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Jobs"
                                    }),
                                    " matched to you"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: (ProfileBanner_module_default()).getStartedButton,
                variant: "contained",
                href: "".concat(profileUrl, "/sign-up"),
                onClick: function() {
                    return track("Click", {
                        action: "Profile banner - get started",
                        "element text": "Get started",
                        "element type": "button"
                    });
                },
                children: "Get started"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                "aria-label": "close",
                className: (ProfileBanner_module_default()).closeButton,
                onClick: onBannerClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ProfileBanner/index.ts



/***/ }),

/***/ 77135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* reexport */ TickList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CheckBox.js
var CheckBox = __webpack_require__(62810);
// EXTERNAL MODULE: ./components/TickList/TickList.module.scss
var TickList_module = __webpack_require__(6705);
var TickList_module_default = /*#__PURE__*/__webpack_require__.n(TickList_module);
;// CONCATENATED MODULE: ./components/TickList/assets/medrecruitTick.svg
var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgMedrecruitTick = function SvgMedrecruitTick(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/react.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#00CBAB"
  })), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "m15.056 21.76-4.522-4.522 1.13-1.13 3.392 3.39 7.279-7.278 1.13 1.13-8.409 8.41Z",
    fill: "#11181C"
  })));
};
/* harmony default export */ var medrecruitTick = (SvgMedrecruitTick);
;// CONCATENATED MODULE: ./components/TickList/TickList.tsx






var TickList = function(param) {
    var items = param.items, variant = param.variant, className = param.className, itemRenderFunction = param.itemRenderFunction;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((TickList_module_default()).container, variant === "small" && (TickList_module_default()).container_small, className),
        children: items.map(function(item, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TickList_module_default()).listItem,
                children: [
                    variant === "medrecruitTick" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(medrecruitTick, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* default */.Z, {
                        className: (TickList_module_default()).checkIcon
                    }),
                    itemRenderFunction ? itemRenderFunction(item) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: item
                    })
                ]
            }, i);
        })
    });
};

;// CONCATENATED MODULE: ./components/TickList/index.ts



/***/ }),

/***/ 77439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ CMSContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _app_components_ProfileBanner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82898);
/* harmony import */ var _modules_LandingHeaderV2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22952);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var modules_Footer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2910);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26152);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_7__);







// import LandingHeader from 'modules/LandingHeader';

var CookieConsentPrompt = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return __webpack_require__.e(/* import() */ 1273).then(__webpack_require__.bind(__webpack_require__, 26871));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26871)
            ];
        }
    }
});
var CMSContainer = function(param) {
    var children = param.children, shouldUpdateFooterStyles = param.shouldUpdateFooterStyles;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_7___default().outsideContainer),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_LandingHeaderV2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_Footer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(shouldUpdateFooterStyles && (_style_module_scss__WEBPACK_IMPORTED_MODULE_7___default().footer))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CookieConsentPrompt, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ProfileBanner__WEBPACK_IMPORTED_MODULE_1__/* .ProfileBanner */ .c, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CMSContainer);


/***/ }),

/***/ 96770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./modules/HomePageV2/HomePageV2.module.scss
var HomePageV2_module = __webpack_require__(64151);
var HomePageV2_module_default = /*#__PURE__*/__webpack_require__.n(HomePageV2_module);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/SectionContainer/SectionContainer.module.scss
var SectionContainer_module = __webpack_require__(64786);
var SectionContainer_module_default = /*#__PURE__*/__webpack_require__.n(SectionContainer_module);
;// CONCATENATED MODULE: ./components/SectionContainer/SectionContainer.tsx




var SectionContainer = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((SectionContainer_module_default()).sectionContainer, className),
        ref: ref,
        children: children
    });
});
SectionContainer.displayName = "SectionContainer";
/* harmony default export */ var SectionContainer_SectionContainer = (SectionContainer);

// EXTERNAL MODULE: ./utils/appClientConfig.ts
var appClientConfig = __webpack_require__(77469);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./modules/HomePageV2/sections/DigitalSolutions/DigitalSolutionsSection.module.scss
var DigitalSolutionsSection_module = __webpack_require__(7981);
var DigitalSolutionsSection_module_default = /*#__PURE__*/__webpack_require__.n(DigitalSolutionsSection_module);
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/DigitalSolutions/assets/digital-solutions-1.png
/* harmony default export */ var digital_solutions_1 = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/digital-solutions-1.df4969de.png","height":442,"width":640,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAVFBMVEVMaXEDQ6uMXEIqb7AWa8OXr+BJfbQCSLcGTbU9YJgqV6CDrcW4x/agpL6Ynbl+cXcZGBIkFQCPpNKhe2cARbMMXrxDUXd1amOUdHg5c4mbdGtIZJ6dszJIAAAAFHRSTlMAWP7+/f39Wf79/P7+/v69PCP98KfSoYMAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA4SURBVAiZBcEHAoAgDATBRYEEG5bD+v9/OgPAugFmFo5qgSb5+8kpQ07zHkWfxzQtRbT4XHd3+g8wxAIeQ9x+HwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/DigitalSolutions/assets/digital-solutions-2.png
/* harmony default export */ var digital_solutions_2 = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/digital-solutions-2.00ea57b3.png","height":422,"width":640,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAS1BMVEUDS7UWXcOZh4mIjrmAepYiX6cAR7E+fNk0bMFNbK8UOXQARbOIbGYQVrlHa64JVaokZ8UYaKFxc54NSKMqUJKuintaf8S6mItVYpfusloVAAAAC3RSTlOC+/z8/pHu+/71rzo/9WUAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAySURBVAiZBcEHAoAgEASxUcA7WKwU/f9LTSBBqQnOW2qri8XMcgzO7tfxfHGySX3UN/8c2gGV7+RZ4wAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/DigitalSolutions/assets/digital-solutions-3.png
/* harmony default export */ var digital_solutions_3 = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/digital-solutions-3.48a88633.png","height":436,"width":640,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAARVBMVEUBSrEleJaVa1kcb5kVUKQASrQAR7UKVLAxf6I7X5cuWIqhjI8YSYqQjaIAOa0AK7l4coC2iXUoXaV3YGEfcJtXZH9mdJh0tZjaAAAAEHRSTlP++/7+/VhZ/v79/ej7tlRHkrGlvgAAAAlwSFlzAAALEwAACxMBAJqcGAAAADFJREFUCJkFwQECgCAIALHLUKDUKLX/P9WNXErud3tgmhI/cJhWvwRO+2KFg6qM9PoGHnEBZIQJ0p0AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/DigitalSolutions/assets/digital-solutions-4.png
/* harmony default export */ var digital_solutions_4 = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/digital-solutions-4.f79b93a7.png","height":422,"width":640,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAUVBMVEUFSLuNSRlYaJJEVHMASLItVJJ0n9pQhswmIyQeXrxwhKtDNzE2XqOme2HN3ecARrUcFhMAAAdfZISYt9o1cb9nbotBXYtSNyY4T3K6l4Rgjc5cNawyAAAAD3RSTlN+/u677vv7/f6Hrf37/PsylkznAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMUlEQVQImQXBhQEAIAwDsOLOcPv/UBLAOfgrgNEfrXQIJmtlbYgY3cxSWYMkaqVu/gEqgAH/YcH61QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/DigitalSolutions/DigitalSolutionsSection.tsx











var digitalSolutions = [
    {
        title: "Create your profile",
        text: "Register and build your Digital Doctor Profile to match with roles tailored to your skills and preferences quickly.",
        image: digital_solutions_1
    },
    {
        title: "Meet your recruiter",
        text: "You’ll be matched with your dedicated recruiter who is an expert in your grade and specialty.",
        image: digital_solutions_2
    },
    {
        title: "Share your goals",
        text: "They’ll find the right jobs and negotiate top rates to fit your career and lifestyle needs.",
        image: digital_solutions_3
    },
    {
        title: "Leave the logistics to us",
        text: "We’ll handle travel, admin, and paperwork so you can focus on your career.",
        image: digital_solutions_4
    }, 
];
var DigitalSolutionsSection = function() {
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var _practitionerProfileUrl;
    var profileUrl = (_practitionerProfileUrl = appClientConfig/* appClientConfig.practitionerProfileUrl */.p.practitionerProfileUrl) !== null && _practitionerProfileUrl !== void 0 ? _practitionerProfileUrl : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionContainer_SectionContainer, {
        className: (DigitalSolutionsSection_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                className: (DigitalSolutionsSection_module_default()).sectionTitle,
                children: [
                    "Finding your next job ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "just got easier"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (DigitalSolutionsSection_module_default()).itemsContainer,
                children: digitalSolutions.map(function(param) {
                    var image = param.image, title = param.title, text = param.text;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (DigitalSolutionsSection_module_default()).solutionItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: image,
                                priority: false,
                                alt: "",
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (DigitalSolutionsSection_module_default()).solutionTitle,
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (DigitalSolutionsSection_module_default()).solutionText,
                                        children: text
                                    })
                                ]
                            })
                        ]
                    }, title);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "contained",
                className: (DigitalSolutionsSection_module_default()).registerButton,
                href: "".concat(profileUrl, "/sign-up"),
                onClick: function() {
                    return track("Click", {
                        action: "Digital solutions section - Register",
                        "element text": "Register now",
                        "element type": "button"
                    });
                },
                children: "Register now"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Accordion/Accordion.js + 1 modules
var Accordion = __webpack_require__(9607);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/AccordionSummary/AccordionSummary.js
var AccordionSummary = __webpack_require__(50743);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/AccordionDetails/AccordionDetails.js
var AccordionDetails = __webpack_require__(61201);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandMore.js
var ExpandMore = __webpack_require__(64566);
// EXTERNAL MODULE: ./components/Accordion/Accordion.module.scss
var Accordion_module = __webpack_require__(58471);
var Accordion_module_default = /*#__PURE__*/__webpack_require__.n(Accordion_module);
;// CONCATENATED MODULE: ./components/Accordion/Accordion.tsx





var Accordion_Accordion = function(param) {
    var title = param.title, children = param.children, _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, testId = param.testId, top = param.top, bottom = param.bottom;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Accordion_module_default()).accordion,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
            "data-testid": testId,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                    expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                        className: classnames_default()((Accordion_module_default()).icon, (Accordion_module_default())[variant])
                    }),
                    className: classnames_default()((Accordion_module_default()).accordionSummary, (Accordion_module_default())[variant], top && (Accordion_module_default()).accordion_top, bottom && (Accordion_module_default()).accordion_bottom),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Accordion_module_default()).accordionTitle,
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                    className: (Accordion_module_default()).accordionDetails,
                    children: children
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./modules/HomePageV2/staticData/faqData.tsx



var linkProps = {
    target: "_blank",
    rel: "noreferrer noopener"
};
var faqData = [
    {
        title: "What does a medical recruitment agency do?",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "We find our doctors",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    href: "https://medrecruit.medworld.com/doctors/locum-jobs-australia"
                }, linkProps), {
                    children: "locum placements"
                })),
                " ",
                "or",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    href: "https://medrecruit.medworld.com/doctors/permanent-jobs-australia-new-zealand"
                }, linkProps), {
                    children: "permanent (full-time) positions"
                })),
                " ",
                "to suit your career or lifestyle goals. Our team of recruitment specialists takes care of the medical job search, pay negotiation, paperwork, and travel logistics - so you can focus on practicing medicine. We form strong relationships with the healthcare facilities to ensure a seamless match between doctors and institutions for the most mutually beneficial partnerships."
            ]
        }),
        plainTextContent: "We find our doctors locum placements or permanent (full-time) positions to suit your career or lifestyle goals. Our team of recruitment specialists takes care of the medical job search, pay negotiation, paperwork, and travel logistics - so you can focus on practicing medicine. We form strong relationships with the healthcare facilities to ensure a seamless match between doctors and institutions for the most mutually beneficial partnerships."
    },
    {
        title: "What is Medrecruit?",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Medrecruit is doctor owned and operated recruitment agency, specialising in",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    href: "https://medrecruit.medworld.com/doctors/permanent-jobs-australia-new-zealand"
                }, linkProps), {
                    children: "permanent"
                })),
                " ",
                "and",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    href: "https://medrecruit.medworld.com/doctors/locum-jobs-australia"
                }, linkProps), {
                    children: "locum jobs."
                })),
                " ",
                "We are committed to connecting doctors with job opportunities that fit their career and lifestyle goals and our exclusive network of jobs across Australasia allows us to personalise each placement. Whether you're after long-term or short-term work, locum or permanent positions - we've got you covered."
            ]
        }),
        plainTextContent: "Medrecruit is doctor owned and operated recruitment agency, specialising in permanent and locum jobs. We are committed to connecting doctors with job opportunities that fit their career and lifestyle goals and our exclusive network of jobs across Australasia allows us to personalise each placement. Whether you're after long-term or short-term work, locum or permanent positions - we've got you covered."
    },
    {
        title: "Why should I work with a medical recruitment agency?",
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Known as one of the best medical locum recruitment agencies in Australia and New Zealand, we're preferred suppliers to hospitals and health care practices across Australasia. This means we can get jobs to you before they've reached the market. Our recruiters and dedicated placement teams go the extra mile to deliver exceptional service and be the very best locum agency. Our consultants are experienced, knowledgeable and strong negotiators. They will find the right job for you at the best rate."
        }),
        plainTextContent: "Known as one of the best medical locum recruitment agencies in Australia and New Zealand, we're preferred suppliers to hospitals and health care practices across Australasia. This means we can get jobs to you before they've reached the market. Our recruiters and dedicated placement teams go the extra mile to deliver exceptional service and be the very best locum agency. Our consultants are experienced, knowledgeable and strong negotiators. They will find the right job for you at the best rate."
    },
    {
        title: "Who do you work with?",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "As a doctor recruitment agency, we work with medical doctors to help them find work in",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    href: "https://medrecruit.medworld.com/doctors/doctor-jobs-australia"
                }, linkProps), {
                    children: "Australia"
                })),
                " ",
                "and",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    href: "https://medrecruit.medworld.com/doctors/doctor-jobs-new-zealand"
                }, linkProps), {
                    children: "New Zealand"
                })),
                ". We have thousands of",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    href: "https://medrecruit.medworld.com/doctors/locum-jobs-australia"
                }, linkProps), {
                    children: "locum roles"
                })),
                " ",
                "and",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    href: "https://medrecruit.medworld.com/doctors/permanent-jobs-australia-new-zealand"
                }, linkProps), {
                    children: "full-time roles"
                })),
                " ",
                "in hospitals and general practices across Australasia on our books. We specialise in doctor recruitment, so if you are a medical doctor looking for a new career in Australia or New Zealand we would love to help!"
            ]
        }),
        plainTextContent: "As a doctor recruitment agency, we work with medical doctors to help them find work in Australia and New Zealand. We have thousands of locum roles and full-time roles in hospitals and general practices across Australasia on our books. We specialise in doctor recruitment, so if you are a medical doctor looking for a new career in Australia or New Zealand we would love to help!"
    },
    {
        title: "What is locum work?",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Locum work, also known as locum tenens positions, for medical doctors in",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    href: "https://medrecruit.medworld.com/doctors/locum-jobs-australia"
                }, linkProps), {
                    children: "Australia"
                })),
                " ",
                "and",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    href: "https://medrecruit.medworld.com/doctors/locum-jobs-new-zealand"
                }, linkProps), {
                    children: "New Zealand"
                })),
                " ",
                "refers to temporary positions that provide flexibility in scheduling and diverse clinical experiences. Doctors can take on short-term assignments to cover staff shortages or fill in for colleagues on leave, often facilitated through locum agencies with expert locum recruiters. This allows them to gain exposure to various healthcare settings, enhance their skills, maintain a healthy work-life balance, and, oftentimes, earn more. Locum work is an excellent option for those seeking variety in their medical career or exploring different regions."
            ]
        }),
        plainTextContent: "Locum work, also known as locum tenens positions, for medical doctors in Australia and New Zealand refers to temporary positions that provide flexibility in scheduling and diverse clinical experiences. Doctors can take on short-term assignments to cover staff shortages or fill in for colleagues on leave, often facilitated through locum agencies with expert locum recruiters. This allows them to gain exposure to various healthcare settings, enhance their skills, maintain a healthy work-life balance, and, oftentimes, earn more. Locum work is an excellent option for those seeking variety in their medical career or exploring different regions."
    },
    {
        title: "What are the benefits of working as a locum doctor in Australia and New Zealand?",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Working as a locum doctor in",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    href: "https://medrecruit.medworld.com/doctors/locum-jobs-australia"
                }, linkProps), {
                    children: "Australia"
                })),
                " ",
                "and",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    href: "https://medrecruit.medworld.com/doctors/locum-jobs-new-zealand"
                }, linkProps), {
                    children: "New Zealand"
                })),
                " ",
                "presents a myriad of benefits. These positions offer flexibility, allowing doctors to tailor their schedules and explore diverse healthcare environments. With the assistance of locum agencies in Australia and New Zealand, doctors can seamlessly navigate the recruitment process, leveraging the expertise of recruitment agencies for medical staff to secure rewarding opportunities. Beyond flexibility, locum roles often boast competitive pay rates, free travel and accommodation, making them highly sought-after. By working with a trusted locum tenens agency, doctors gain access to a vast network of locum opportunities across various specialties and regions. Whether you're an experienced practitioner or seeking to embark on a new adventure, locum positions offer unparalleled flexibility and diversity in both Australia and New Zealand."
            ]
        }),
        plainTextContent: "Working as a locum doctor in Australia and New Zealand presents a myriad of benefits. These positions offer flexibility, allowing doctors to tailor their schedules and explore diverse healthcare environments. With the assistance of locum agencies in Australia and New Zealand, doctors can seamlessly navigate the recruitment process, leveraging the expertise of recruitment agencies for medical staff to secure rewarding opportunities. Beyond flexibility, locum roles often boast competitive pay rates, free travel and accommodation, making them highly sought-after. By working with a trusted locum tenens agency, doctors gain access to a vast network of locum opportunities across various specialties and regions. Whether you're an experienced practitioner or seeking to embark on a new adventure, locum positions offer unparalleled flexibility and diversity in both Australia and New Zealand."
    },
    {
        title: "Can I work as a doctor in Australia and New Zealand as an International Medical Graduate?",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "As an International Medical Graduate (IMG), working in",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    href: "https://medrecruit.medworld.com/doctors/doctor-jobs-new-zealand"
                }, linkProps), {
                    children: "New Zealand"
                })),
                " ",
                "and",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    href: "https://medrecruit.medworld.com/doctors/doctor-jobs-australia"
                }, linkProps), {
                    children: "Australia"
                })),
                " ",
                "is indeed possible. However, it involves a structured process overseen by the respective medical councils. In Australia, the Medical Council of Australia manages the registration process, and in New Zealand, the Medical Council of New Zealand ensures that IMGs meet the required standards and qualifications. Partnering with a doctor recruitment agency like Medrecruit can help facilitate the transition process for IMGs, guiding them through the registration process and assisting in securing suitable placements. These agencies specialise in connecting doctors with opportunities across various healthcare settings, ensuring a smooth transition into working in New Zealand and Australia for IMGs seeking fulfilling careers in these countries. Head to",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    href: "https://medrecruit.medworld.com/doctors/international"
                }, linkProps), {
                    children: "this page for IMGs"
                })),
                " ",
                "for more information on how Medrecruit can support."
            ]
        }),
        plainTextContent: "As an International Medical Graduate (IMG), working in New Zealand and Australia is indeed possible. However, it involves a structured process overseen by the respective medical councils. In Australia, the Medical Council of Australia manages the registration process, and in New Zealand, the Medical Council of New Zealand ensures that IMGs meet the required standards and qualifications. Partnering with a doctor recruitment agency like Medrecruit can help facilitate the transition process for IMGs, guiding them through the registration process and assisting in securing suitable placements. These agencies specialise in connecting doctors with opportunities across various healthcare settings, ensuring a smooth transition into working in New Zealand and Australia for IMGs seeking fulfilling careers in these countries. Head to this page for IMGs for more information on how Medrecruit can support."
    }, 
];
var faqSeoSchemaData = faqData.map(function(param) {
    var title = param.title, plainTextContent = param.plainTextContent;
    return {
        questionName: title,
        acceptedAnswerText: plainTextContent
    };
});

;// CONCATENATED MODULE: ./utils/slugify.ts
var slugify = function(text) {
    return text.toLowerCase().replace(/[^a-z0-9]+/g, "-") // replace non-alphanumerics with hyphens
    .replace(/(^-|-$)+/g, "");
}; // trim hyphens

// EXTERNAL MODULE: ./modules/HomePageV2/sections/FAQ/FaqSection.module.scss
var FaqSection_module = __webpack_require__(1477);
var FaqSection_module_default = /*#__PURE__*/__webpack_require__.n(FaqSection_module);
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/FAQ/FaqSection.tsx






var FaqSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionContainer_SectionContainer, {
        className: (FaqSection_module_default()).faqSectionContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                className: (FaqSection_module_default()).faqSectionTitle,
                children: [
                    "Medical Recruitment ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Agency FAQs"
                    })
                ]
            }),
            faqData.map(function(param, index) {
                var title = param.title, content = param.content;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion_Accordion, {
                    title: title,
                    top: index === 0,
                    bottom: index === faqData.length - 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (FaqSection_module_default()).faqSectionContent,
                        children: content
                    })
                }, slugify(title));
            })
        ]
    });
};

// EXTERNAL MODULE: ./utils/jobListingHelper.ts
var jobListingHelper = __webpack_require__(92628);
;// CONCATENATED MODULE: ./modules/HomePageV2/assets/leftTears.svg
var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgLeftTears = function SvgLeftTears(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 195,
    height: 496,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 496c44.194 0 80-34.106 80-76.216a72.953 72.953 0 0 0-6.88-30.956L6.875 216l-71.1 170.995C-69.212 396.961-72 408.089-72 419.784-72 461.868-36.169 496 8 496Z",
    fill: "url(#leftTears_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5-37C26.561-37-22 9.774-22 67.525c0 15.083 3.33 29.459 9.33 42.454L88.027 347l96.429-234.507C191.219 98.825 195 83.564 195 67.525 195 9.809 146.404-37 86.5-37Z",
    fill: "url(#leftTears_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "leftTears_svg__a",
    x1: -76.797,
    y1: 200.651,
    x2: 173.001,
    y2: 324.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#106BF7"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#053589"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "leftTears_svg__b",
    x1: 87.278,
    y1: 347.358,
    x2: -91.424,
    y2: 97.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#106BF7"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#053589"
  })))));
};
/* harmony default export */ var leftTears = (SvgLeftTears);
;// CONCATENATED MODULE: ./modules/HomePageV2/assets/rightTears.svg
var rightTears_path, rightTears_path2, rightTears_defs;
function rightTears_extends() { return rightTears_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, rightTears_extends.apply(null, arguments); }

var SvgRightTears = function SvgRightTears(props) {
  return /*#__PURE__*/react.createElement("svg", rightTears_extends({
    width: 195,
    height: 496,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), rightTears_path || (rightTears_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187 504c-44.194 0-80-34.106-80-76.216a72.947 72.947 0 0 1 6.88-30.956L188.125 224l71.1 170.995c4.987 9.966 7.775 21.094 7.775 32.789C267 469.868 231.169 504 187 504Z",
    fill: "url(#rightTears_svg__a)"
  })), rightTears_path2 || (rightTears_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.5-29C168.439-29 217 17.774 217 75.525c0 15.083-3.33 29.459-9.331 42.454L106.974 355l-96.43-234.507C3.782 106.825 0 91.564 0 75.525 0 17.809 48.596-29 108.5-29Z",
    fill: "url(#rightTears_svg__b)"
  })), rightTears_defs || (rightTears_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "rightTears_svg__a",
    x1: 271.797,
    y1: 208.651,
    x2: 21.999,
    y2: 332.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#106BF7"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#053589"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "rightTears_svg__b",
    x1: 107.722,
    y1: 355.358,
    x2: 286.424,
    y2: 105.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#106BF7"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#053589"
  })))));
};
/* harmony default export */ var rightTears = (SvgRightTears);
// EXTERNAL MODULE: ./utils/jobSearchBoxOptions.tsx
var jobSearchBoxOptions = __webpack_require__(73208);
// EXTERNAL MODULE: ./utils/jobSearchCookies.tsx
var jobSearchCookies = __webpack_require__(80059);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(90387);
// EXTERNAL MODULE: ./modules/HomePageV2/sections/JobSearchHeader/JobSearchHeader.module.scss
var JobSearchHeader_module = __webpack_require__(39778);
var JobSearchHeader_module_default = /*#__PURE__*/__webpack_require__.n(JobSearchHeader_module);
// EXTERNAL MODULE: ./modules/HomePageV2/sections/JobSearchHeader/components/MedrecruitStats/MedrecruitStats.module.scss
var MedrecruitStats_module = __webpack_require__(76173);
var MedrecruitStats_module_default = /*#__PURE__*/__webpack_require__.n(MedrecruitStats_module);
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/JobSearchHeader/components/MedrecruitStats/MedrecruitStats.tsx


var MedrecruitStats = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (MedrecruitStats_module_default()).statsContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (MedrecruitStats_module_default()).statsItem,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (MedrecruitStats_module_default()).statsHeader,
                        children: "5000+"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (MedrecruitStats_module_default()).statsSubText,
                        children: "doctors placed every year"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (MedrecruitStats_module_default()).statsItem,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (MedrecruitStats_module_default()).statsHeader,
                        children: "18+"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (MedrecruitStats_module_default()).statsSubText,
                        children: "years industry experience"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (MedrecruitStats_module_default()).statsItem,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (MedrecruitStats_module_default()).statsHeader,
                        children: "3x"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (MedrecruitStats_module_default()).statsSubText,
                        children: "more jobs than the next agency"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ExpandLess.js
var ExpandLess = __webpack_require__(35025);
// EXTERNAL MODULE: ./modules/HomePageV2/sections/JobSearchHeader/components/formInputs/GradeSelect/GradeSelect.module.scss
var GradeSelect_module = __webpack_require__(39677);
var GradeSelect_module_default = /*#__PURE__*/__webpack_require__.n(GradeSelect_module);
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/JobSearchHeader/components/formInputs/GradeSelect/GradeSelect.tsx





var GRADE_OPTIONS = [
    "Resident Medical Officer",
    "Registrar",
    "SMO/MOSS",
    "Specialist Consultant",
    "Clinical Director",
    "Director of Medical Services", 
];
var GradeSelect = function(param) {
    var value = param.value, onChange = param.onChange, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "I'm a..." : _placeholder, _id = param.id, id = _id === void 0 ? "grade-select" : _id;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var dropdownRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var handleClickOutside = function(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        var handleKeyDown = function(event) {
            if (event.key === "Escape" && isOpen) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleKeyDown);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        isOpen
    ]);
    var handleToggle = function() {
        setIsOpen(!isOpen);
    };
    var handleOptionSelect = function(option) {
        onChange(option);
        setIsOpen(false);
    };
    var handleButtonKeyDown = function(event) {
        switch(event.key){
            case "Enter":
            case " ":
                event.preventDefault();
                setIsOpen(!isOpen);
                break;
            case "ArrowDown":
                event.preventDefault();
                setIsOpen(true);
                break;
            case "ArrowUp":
                event.preventDefault();
                setIsOpen(true);
                break;
        }
    };
    var displayValue = value !== null && value !== void 0 ? value : placeholder;
    var labelId = "".concat(id, "-label");
    var buttonId = "".concat(id, "-button");
    var listboxId = "".concat(id, "-listbox");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (GradeSelect_module_default()).gradeSelect,
        ref: dropdownRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (GradeSelect_module_default()).label,
                id: labelId,
                htmlFor: buttonId,
                children: "Grade"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                id: buttonId,
                type: "button",
                className: (GradeSelect_module_default()).selectButton,
                onClick: handleToggle,
                onKeyDown: handleButtonKeyDown,
                "aria-haspopup": "listbox",
                "aria-expanded": isOpen,
                "aria-labelledby": labelId,
                "aria-describedby": value ? undefined : "".concat(id, "-placeholder"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (GradeSelect_module_default()).selectText,
                        children: displayValue
                    }),
                    isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandLess/* default */.Z, {
                        className: (GradeSelect_module_default()).arrow
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                        className: (GradeSelect_module_default()).arrow
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (GradeSelect_module_default()).dropdown,
                role: "listbox",
                id: listboxId,
                "aria-labelledby": labelId,
                children: GRADE_OPTIONS.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (GradeSelect_module_default()).option,
                        role: "option",
                        "aria-selected": value === option,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: (GradeSelect_module_default()).optionButton,
                            onClick: function() {
                                return handleOptionSelect(option);
                            },
                            onKeyDown: function(e) {
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    handleOptionSelect(option);
                                }
                            },
                            children: option
                        })
                    }, option);
                })
            })
        ]
    });
};
/* harmony default export */ var GradeSelect_GradeSelect = ((/* unused pure expression or super */ null && (GradeSelect)));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./services/locationService.ts
var locationService = __webpack_require__(2589);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField = __webpack_require__(39803);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Autocomplete/Autocomplete.js + 3 modules
var Autocomplete = __webpack_require__(53437);
// EXTERNAL MODULE: ./modules/HomePageV2/sections/JobSearchHeader/components/formInputs/LocationAutoComplete/LocationAutoComplete.module.scss
var LocationAutoComplete_module = __webpack_require__(16122);
var LocationAutoComplete_module_default = /*#__PURE__*/__webpack_require__.n(LocationAutoComplete_module);
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/JobSearchHeader/components/formInputs/LocationAutoComplete/LocationAutoComplete.tsx
















var LocationOption = function(param) {
    var option = param.option;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        className: (0,clsx_m/* default */.Z)((LocationAutoComplete_module_default()).option, option.divider && (LocationAutoComplete_module_default()).divider),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (LocationAutoComplete_module_default()).optionContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (LocationAutoComplete_module_default()).locationName,
                    children: option.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (LocationAutoComplete_module_default()).locationSubtitle,
                    children: "city" in option ? [
                        option.city,
                        option.state,
                        option.country
                    ].filter(Boolean).join(", ") : option.country
                })
            ]
        })
    });
};
var LocationInput = function(param) {
    var params = param.params, placeholder = param.placeholder, onFocus = param.onFocus, onChange = param.onChange, onBlur = param.onBlur;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
        placeholder: placeholder,
        InputProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params.InputProps), {
            disableUnderline: true
        }),
        onFocus: onFocus,
        onChange: function(e) {
            return onChange(e.target.value);
        },
        onBlur: onBlur
    }));
};
var LocationAutoComplete = function(param) {
    var value = param.value, onChange = param.onChange, className = param.className, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "Where..." : _placeholder, _label = param.label, label = _label === void 0 ? "Location" : _label;
    var ref = (0,react.useState)([]), locations = ref[0], setLocations = ref[1];
    var ref1 = (0,react.useState)(""), searchTerm = ref1[0], setSearchTerm = ref1[1];
    var ref2 = (0,react.useState)(false), openOptions = ref2[0], setOpenOptions = ref2[1];
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var onSearchTermChange = lodash_debounce_default()(function(term) {
        return setSearchTerm(term);
    }, 500);
    (0,react.useEffect)(function() {
        if (searchTerm.length < 2) {
            setOpenOptions(false);
            return;
        }
        setLocations([]);
        setLoading(true);
        setOpenOptions(true);
        var fetchLocations = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var data, mappedSchedulerLocations, combinedLocations, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (0,locationService/* searchLocation */.h)(searchTerm)
                            ];
                        case 1:
                            data = _state.sent();
                            mappedSchedulerLocations = data.locations.map(function(loc, idx) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, loc), {
                                    divider: idx === data.locations.length - 1
                                });
                            });
                            combinedLocations = (0,_to_consumable_array/* default */.Z)(mappedSchedulerLocations).concat((0,_to_consumable_array/* default */.Z)(data.results));
                            setLocations(combinedLocations);
                            setLoading(false);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            setLocations([]);
                            setLoading(false);
                            setOpenOptions(false);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchLocations() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchLocations();
    }, [
        searchTerm
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((LocationAutoComplete_module_default()).container, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (LocationAutoComplete_module_default()).label,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.ZP, {
                value: value,
                onChange: function(_event, newValue) {
                    onChange(newValue);
                    setOpenOptions(false);
                },
                options: locations,
                open: openOptions,
                loading: loading,
                autoHighlight: true,
                filterOptions: function(options) {
                    return options;
                },
                popupIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                clearOnBlur: true,
                getOptionLabel: function(option) {
                    return option.name;
                },
                getOptionSelected: function(option, value) {
                    return option.name === value.name;
                },
                ListboxProps: {
                    style: {
                        maxHeight: 300,
                        overflow: "auto"
                    }
                },
                loadingText: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    style: {
                        gap: 8
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            size: 20
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Searching..."
                        })
                    ]
                }),
                noOptionsText: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (LocationAutoComplete_module_default()).noOptions,
                    children: [
                        'No locations found for "',
                        searchTerm,
                        '"'
                    ]
                }),
                renderOption: function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOption, {
                        option: option
                    });
                },
                renderInput: function(params) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationInput, {
                        params: params,
                        placeholder: placeholder,
                        onFocus: function() {
                            setOpenOptions(false);
                            setSearchTerm("");
                        },
                        onChange: onSearchTermChange,
                        onBlur: function() {
                            return setOpenOptions(false);
                        }
                    });
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./modules/HomePageV2/sections/JobSearchHeader/components/formInputs/SearchButton/SearchButton.module.scss
var SearchButton_module = __webpack_require__(66514);
var SearchButton_module_default = /*#__PURE__*/__webpack_require__.n(SearchButton_module);
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/JobSearchHeader/components/formInputs/SearchButton/SearchButton.tsx





var SearchButton = function(param) {
    var _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _loading = param.loading, loading = _loading === void 0 ? false : _loading, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (SearchButton_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            type: "submit",
            variant: "contained",
            className: "".concat((SearchButton_module_default()).searchButton, " ").concat(className),
            disabled: disabled || loading,
            fullWidth: true,
            children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                size: 20,
                className: (SearchButton_module_default()).spinner
            }) : "Search"
        })
    });
};
/* harmony default export */ var SearchButton_SearchButton = ((/* unused pure expression or super */ null && (SearchButton)));

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Check.js
var Check = __webpack_require__(41959);
// EXTERNAL MODULE: ./modules/HomePageV2/sections/JobSearchHeader/components/formInputs/WorkTypeCheckboxGroup/WorkTypeCheckboxGroup.module.scss
var WorkTypeCheckboxGroup_module = __webpack_require__(73939);
var WorkTypeCheckboxGroup_module_default = /*#__PURE__*/__webpack_require__.n(WorkTypeCheckboxGroup_module);
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/JobSearchHeader/components/formInputs/WorkTypeCheckboxGroup/WorkTypeCheckboxGroup.tsx





var WorkTypeCheckboxGroup = function(param) {
    var value = param.value, onChange = param.onChange, _id = param.id, id = _id === void 0 ? "work-type-checkbox-group" : _id;
    var handleCheckboxChange = function(optionValue, isChecked) {
        if (!isChecked) {
            // Remove from array
            onChange(value.filter(function(v) {
                return v !== optionValue;
            }));
            return;
        }
        onChange((0,_to_consumable_array/* default */.Z)(value).concat([
            optionValue
        ]));
    };
    var labelId = "".concat(id, "-label");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (WorkTypeCheckboxGroup_module_default()).workTypeCheckboxGroup,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (WorkTypeCheckboxGroup_module_default()).label,
                id: labelId,
                children: "Interested in"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (WorkTypeCheckboxGroup_module_default()).checkboxContainer,
                role: "group",
                "aria-labelledby": labelId,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: (WorkTypeCheckboxGroup_module_default()).checkboxLabel,
                        htmlFor: "".concat(id, "-locum"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "checkbox",
                                id: "".concat(id, "-locum"),
                                checked: value.includes("Locum"),
                                onChange: function(e) {
                                    return handleCheckboxChange("Locum", e.target.checked);
                                },
                                className: (WorkTypeCheckboxGroup_module_default()).hiddenCheckbox
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (WorkTypeCheckboxGroup_module_default()).labelText,
                                children: "Locum"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (WorkTypeCheckboxGroup_module_default()).customCheckbox,
                                children: value.includes("Locum") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                                    className: (WorkTypeCheckboxGroup_module_default()).checkIcon
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: (WorkTypeCheckboxGroup_module_default()).checkboxLabel,
                        htmlFor: "".concat(id, "-permanent"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "checkbox",
                                id: "".concat(id, "-permanent"),
                                checked: value.includes("Permanent"),
                                onChange: function(e) {
                                    return handleCheckboxChange("Permanent", e.target.checked);
                                },
                                className: (WorkTypeCheckboxGroup_module_default()).hiddenCheckbox
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (WorkTypeCheckboxGroup_module_default()).labelText,
                                children: "Permanent"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (WorkTypeCheckboxGroup_module_default()).customCheckbox,
                                children: value.includes("Permanent") && /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                                    className: (WorkTypeCheckboxGroup_module_default()).checkIcon
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var WorkTypeCheckboxGroup_WorkTypeCheckboxGroup = ((/* unused pure expression or super */ null && (WorkTypeCheckboxGroup)));

;// CONCATENATED MODULE: ./modules/HomePageV2/sections/JobSearchHeader/JobSearchHeader.tsx

















var getWorkTypesSelected = function(workTypes) {
    if (workTypes.length === 1) {
        return workTypes[0];
    }
    return workTypes.length ? "both" : "none";
};
var JobSearchHeader = function() {
    var router = (0,client_router.useRouter)();
    var track = (0,useAnalytics/* useAnalytics */.z)();
    // form state
    var ref = (0,react.useState)(undefined), selectedGrade = ref[0], setSelectedGrade = ref[1];
    var ref1 = (0,react.useState)([]), selectedWorkTypes = ref1[0], setSelectedWorkTypes = ref1[1];
    var ref2 = (0,react.useState)(null), locationCoordinate = ref2[0], setLocationCoordinate = ref2[1];
    var ref3 = (0,react.useState)(false), isSearching = ref3[0], setIsSearching = ref3[1];
    // end of form state
    var handleSearch = function(event) {
        var ref, ref1, ref2;
        event.preventDefault();
        setIsSearching(true);
        var lon = locationCoordinate === null || locationCoordinate === void 0 ? void 0 : (ref = locationCoordinate.position) === null || ref === void 0 ? void 0 : ref.lon.toString();
        var lat = locationCoordinate === null || locationCoordinate === void 0 ? void 0 : (ref1 = locationCoordinate.position) === null || ref1 === void 0 ? void 0 : ref1.lat.toString();
        var isOneWorkTypeSelected = selectedWorkTypes.length === 1;
        var search = {
            grade: selectedGrade,
            location: locationCoordinate === null || locationCoordinate === void 0 ? void 0 : (ref2 = locationCoordinate.searchLocations) === null || ref2 === void 0 ? void 0 : ref2.join(";"),
            lon: lon,
            lat: lat,
            locationName: locationCoordinate === null || locationCoordinate === void 0 ? void 0 : locationCoordinate.name,
            radius: lat && lon ? jobSearchBoxOptions/* DEFAULT_RADIUS */.J_ : undefined,
            page: 1,
            workType: isOneWorkTypeSelected ? selectedWorkTypes[0] : undefined
        };
        if (selectedGrade) {
            (0,jobSearchCookies/* setGradeCookie */.r8)(selectedGrade);
        }
        if (locationCoordinate) {
            (0,jobSearchCookies/* setLocationCookie */.Hl)(locationCoordinate);
        }
        track("Job Search", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, search), {
            autocompleteLocationSelectedType: search.lon ? "specific" : "scheduler",
            autocompleteLocationRadius: null,
            jobSearchSimple: true,
            workTypesSelected: getWorkTypesSelected(selectedWorkTypes)
        }));
        var urlObject = (0,jobListingHelper/* generateJobListingsUrlObject */.hX)(search);
        return router.push(urlObject);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-testid": "job-search-header-v2",
        className: (JobSearchHeader_module_default()).jobSearchHeaderContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(leftTears, {
                className: (JobSearchHeader_module_default()).leftTears
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(rightTears, {
                className: (JobSearchHeader_module_default()).rightTears
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                    className: (JobSearchHeader_module_default()).title,
                    children: [
                        "Search over 3,000 doctor jobs in",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " Australia and New Zealand."
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: (JobSearchHeader_module_default()).searchForm,
                onSubmit: handleSearch,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GradeSelect, {
                        value: selectedGrade,
                        onChange: setSelectedGrade
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WorkTypeCheckboxGroup, {
                        value: selectedWorkTypes,
                        onChange: setSelectedWorkTypes
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationAutoComplete, {
                        value: locationCoordinate,
                        onChange: setLocationCoordinate
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchButton, {
                        loading: isSearching
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MedrecruitStats, {})
        ]
    });
};

;// CONCATENATED MODULE: ./components/SectionContainer/index.ts


// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Search.js
var Search = __webpack_require__(88995);
// EXTERNAL MODULE: ./modules/HomePageV2/sections/JobsSection/JobCategoryButton/JobCategoryButton.module.scss
var JobCategoryButton_module = __webpack_require__(46463);
var JobCategoryButton_module_default = /*#__PURE__*/__webpack_require__.n(JobCategoryButton_module);
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/JobsSection/JobCategoryButton/JobCategoryButton.tsx






var JobCategoryButton = function(param) {
    var title = param.title, url = param.url, imageSrc = param.imageSrc;
    var isDesktop = (0,useMediaQuery/* default */.Z)("(min-width: 880px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        tabIndex: 0,
        href: url,
        as: url,
        prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (JobCategoryButton_module_default()).jobButton,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (JobCategoryButton_module_default()).jobButtonContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: (JobCategoryButton_module_default()).jobButtonTitle,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (JobCategoryButton_module_default()).jobsPill,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {})
                        })
                    ]
                }),
                isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (JobCategoryButton_module_default()).jobButtonImageWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: (JobCategoryButton_module_default()).jobButtonImage,
                        src: imageSrc,
                        alt: title,
                        height: 262,
                        width: 440,
                        priority: false,
                        objectFit: "cover"
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./modules/HomePageV2/sections/JobsSection/JobsSection.module.scss
var JobsSection_module = __webpack_require__(39761);
var JobsSection_module_default = /*#__PURE__*/__webpack_require__.n(JobsSection_module);
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/JobsSection/assets/anaesthetics.jpg
/* harmony default export */ var anaesthetics = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/anaesthetics.deadd8c0.jpg","height":262,"width":440,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAbEAACAgMBAAAAAAAAAAAAAAABAgADBBESYf/EABQBAQAAAAAAAAAAAAAAAAAAAAX/xAAZEQEAAgMAAAAAAAAAAAAAAAABAAIDESH/2gAMAwEAAhEDEQA/AJORe2Hhs1AVXpVT0w66BI2Dv0xERIvYOMLyBuf/2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/JobsSection/assets/emergencyMedicine.jpg
/* harmony default export */ var emergencyMedicine = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/emergencyMedicine.cbaec2b3.jpg","height":262,"width":440,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAeEAACAQMFAAAAAAAAAAAAAAACAwABBRIEEUFRkf/EABQBAQAAAAAAAAAAAAAAAAAAAAX/xAAaEQACAgMAAAAAAAAAAAAAAAAAAQIDEiJx/9oADAMBAAIRAxEAPwCfaNMbre57HmWNCwHgNuvIiI/WlhHiDZPZn//Z","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/JobsSection/assets/generalMedicine.jpg
/* harmony default export */ var generalMedicine = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/generalMedicine.ae6d8ba6.jpg","height":262,"width":440,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAdEAABBAIDAAAAAAAAAAAAAAABAAIDBAUSIVFx/8QAFAEBAAAAAAAAAAAAAAAAAAAABf/EABcRAQEBAQAAAAAAAAAAAAAAAAIBADH/2gAMAwEAAhEDEQA/AJbeLFbFOpPmdJCGGQADXlvnaIiZYMvMaVbv/9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/JobsSection/assets/gp.jpg
/* harmony default export */ var gp = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/gp.388894ce.jpg","height":262,"width":440,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAfEAABBAAHAAAAAAAAAAAAAAABAAIDBAUSEyExYYH/xAAUAQEAAAAAAAAAAAAAAAAAAAAF/8QAGhEAAgIDAAAAAAAAAAAAAAAAAQIAAxESIf/aAAwDAQACEQMRAD8Amw63NPJHSD8jgC3UHe/HiIiaoQWJlobYdTyf/9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/JobsSection/assets/intensiveCare.jpg
/* harmony default export */ var intensiveCare = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/intensiveCare.23a722ca.jpg","height":262,"width":440,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAdEAEAAQMFAAAAAAAAAAAAAAABAAMEEQISMUFh/8QAFQEBAQAAAAAAAAAAAAAAAAAABQb/xAAXEQADAQAAAAAAAAAAAAAAAAABAhEA/9oADAMBAAIRAxEAPwCF6VaRc3RVU2CaE4T3PeYiJVooa3DEzf/Z","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/JobsSection/assets/obstetrics.jpg
/* harmony default export */ var obstetrics = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/obstetrics.2d3b00f3.jpg","height":262,"width":440,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAeEAACAgICAwAAAAAAAAAAAAABAgADBBEFISIxQf/EABQBAQAAAAAAAAAAAAAAAAAAAAX/xAAYEQEAAwEAAAAAAAAAAAAAAAABAAIRIf/aAAwDAQACEQMRAD8AjXh18pgrbZutQWrVEJHjvsE/fUREYFyG24uT/9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/JobsSection/assets/paediatrics.jpg
/* harmony default export */ var paediatrics = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/paediatrics.8f8def53.jpg","height":262,"width":440,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAdEAEAAgEFAQAAAAAAAAAAAAABAAISAwUREyFB/8QAFQEBAQAAAAAAAAAAAAAAAAAABQb/xAAYEQACAwAAAAAAAAAAAAAAAAAAAQIRMf/aAAwDAQACEQMRAD8AhuluqltRM8gGt/amJyIfIiJRuTjgNV6f/9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/JobsSection/assets/psychiatry.jpg
/* harmony default export */ var psychiatry = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/psychiatry.2ad2997e.jpg","height":262,"width":440,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAdEAABBAIDAAAAAAAAAAAAAAABAAIFEQMhBEFh/8QAFQEBAQAAAAAAAAAAAAAAAAAABAX/xAAXEQEBAQEAAAAAAAAAAAAAAAABAgAR/9oADAMBAAIRAxEAPwCRKsHMmWxpa1mFmHVDqgSKvwbREVOJLO1gqzwN/9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/JobsSection/assets/surgery.jpg
/* harmony default export */ var surgery = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/surgery.b63d2a36.jpg","height":262,"width":440,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAdEAABBAIDAAAAAAAAAAAAAAABAAIDBAURITGB/8QAFAEBAAAAAAAAAAAAAAAAAAAABf/EABgRAAMBAQAAAAAAAAAAAAAAAAABAjEh/9oADAMBAAIRAxEAPwCbpZKU0XU5NyRPssjIceA09gDxERPz3QK21h//2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/JobsSection/JobsSection.tsx














var jobButtons = [
    {
        title: "Emergency Medicine",
        url: "/doctors/ed-doctors-jobs-australia",
        imageSrc: emergencyMedicine
    },
    {
        title: "General Medicine",
        url: "/doctors/general-medicine-doctor-jobs-australia",
        imageSrc: generalMedicine
    },
    {
        title: "Psychiatry",
        url: "/doctors/psychiatry-doctor-jobs-australia",
        imageSrc: psychiatry
    },
    {
        title: "Intensive Care",
        url: "/doctors/icu-consultant-jobs-australia",
        imageSrc: intensiveCare
    },
    {
        title: "Surgery",
        url: "/doctors/surgeon-doctor-jobs",
        imageSrc: surgery
    },
    {
        title: "Anaesthetics",
        url: "/doctors/anaesthetics-doctor-jobs-australia",
        imageSrc: anaesthetics
    },
    {
        title: "Paediatrics",
        url: "/doctors/paediatrics-doctor-jobs-australia",
        imageSrc: paediatrics
    },
    {
        title: "Obstetrics and Gynaecology",
        url: "/doctors/obstetrics-and-gynaecology-jobs-australia",
        imageSrc: obstetrics
    },
    {
        title: "GP",
        url: "/doctors/gp-jobs-australia",
        imageSrc: gp
    }, 
];
var JobsSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionContainer_SectionContainer, {
        className: (JobsSection_module_default()).jobsSectionContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                    className: (JobsSection_module_default()).jobsSectionTitle,
                    children: [
                        "Explore the ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "largest network of doctor jobs "
                        }),
                        "in Australasia"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (JobsSection_module_default()).jobsGrid,
                children: jobButtons.map(function(job) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobCategoryButton, (0,_object_spread/* default */.Z)({}, job), job.title);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/Button/index.ts + 1 modules
var components_Button = __webpack_require__(56419);
;// CONCATENATED MODULE: ./modules/HomePageV2/assets/DrDaveSurfing.jpg
/* harmony default export */ var DrDaveSurfing = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/DrDaveSurfing.b850bf76.jpg","height":1660,"width":1440,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAcDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAfEAABAwMFAAAAAAAAAAAAAAABAAIhAwQRBQYxQVH/xAAVAQEBAAAAAAAAAAAAAAAAAAACA//EABcRAQEBAQAAAAAAAAAAAAAAAAEAAhL/2gAMAwEAAhEDEQA/AK3Sd2gXtc3JDaYDYa3OI6n3lERR7ZmS/9k=","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./modules/HomePageV2/assets/DrDaveSurfsUp.jpg
/* harmony default export */ var DrDaveSurfsUp = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/DrDaveSurfsUp.1a7716fe.jpg","height":1660,"width":1440,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAcDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAcEAACAgIDAAAAAAAAAAAAAAAAAQIFAxEEFDH/xAAVAQEBAAAAAAAAAAAAAAAAAAABBP/EABgRAAMBAQAAAAAAAAAAAAAAAAACURIT/9oADAMBAAIRAxEAPwCsORULM5Zb20b912ZPQAHCwn6vT//Z","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./modules/HomePageV2/assets/DrDaveWork.jpg
/* harmony default export */ var DrDaveWork = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/DrDaveWork.77dad3b1.jpg","height":1660,"width":1438,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAcDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAhEAABAgQHAAAAAAAAAAAAAAABAAIEBRJBAwYRFCFCUf/EABUBAQEAAAAAAAAAAAAAAAAAAAID/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQARMf/aAAwDAQACEQMRAD8AlK8+76YYMHNISKBApe1nVwZyaR6bW1CIitgBHrf/2Q==","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./modules/HomePageV2/hooks/useCarousel.ts

/**
 * Hook to manage animated carousel logic including auto-play timer and manual navigation
 * @template T The type of data items in the carousel
 * @param carouselData Array of data
 * @param isVisible Whether the component is visible (controls auto-play)
 * @returns Object with current state and handlers
 *
 * @example
 * ```typescript
 * const MyCarousel = useTestimonialLogic<MyType>({
 *   carouselData: MyTypeArray,
 *   isVisible: true
 * });
 * ```
 */ var useCarousel = function(param) {
    var carouselData = param.carouselData, isVisible = param.isVisible, _transitionDuration = param.transitionDuration, transitionDuration = _transitionDuration === void 0 ? 200 : _transitionDuration, _autoAdvanceInterval = param.autoAdvanceInterval, autoAdvanceInterval = _autoAdvanceInterval === void 0 ? 5000 : _autoAdvanceInterval;
    var ref = (0,react.useState)(0), currentIndex = ref[0], setCurrentIndex = ref[1];
    var ref1 = (0,react.useState)(false), isTransitioning = ref1[0], setIsTransitioning = ref1[1];
    var ref2 = (0,react.useState)(0), animationKey = ref2[0], setAnimationKey = ref2[1];
    var intervalRef = (0,react.useRef)(null);
    // Helper function to clear the timer
    var clearTimer = (0,react.useCallback)(function() {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    // Helper function to advance to next testimonial with transition
    var advanceToNext = (0,react.useCallback)(function() {
        setIsTransitioning(true);
        setTimeout(function() {
            setCurrentIndex(function(prevIndex) {
                return (prevIndex + 1) % carouselData.length;
            });
            setIsTransitioning(false);
        }, transitionDuration);
    }, [
        carouselData.length,
        transitionDuration
    ]);
    // Helper function to start the auto-advance timer
    var startTimer = (0,react.useCallback)(function() {
        if (isVisible) {
            intervalRef.current = setInterval(advanceToNext, autoAdvanceInterval);
        }
    }, [
        isVisible,
        advanceToNext,
        autoAdvanceInterval
    ]);
    // Auto-play timer effect
    (0,react.useEffect)(function() {
        if (!isVisible) {
            return;
        }
        startTimer();
        return clearTimer;
    }, [
        isVisible,
        startTimer,
        clearTimer
    ]);
    // Reset animation when visibility changes
    (0,react.useEffect)(function() {
        setAnimationKey(function(prev) {
            return prev + 1;
        });
    }, [
        isVisible
    ]);
    // TODO: extract this to be a part of a Carousel component when we need it. It works for now at reducing the noise of Testimonials.tsx
    var handleIndicatorClick = function(indicatorIndex) {
        // Only reset timer if user navigates to a different testimonial
        if (indicatorIndex === currentIndex) {
            return;
        }
        clearTimer();
        setIsTransitioning(true);
        setAnimationKey(function(prev) {
            return prev + 1;
        }); // Restart progress bar animation
        setTimeout(function() {
            setCurrentIndex(indicatorIndex);
            setIsTransitioning(false);
        }, transitionDuration);
        startTimer(); // Restart timer
    // If clicking current indicator, do nothing (no timer reset)
    };
    var currentItem = carouselData[currentIndex];
    return {
        currentIndex: currentIndex,
        currentItem: currentItem,
        isTransitioning: isTransitioning,
        animationKey: animationKey,
        handleIndicatorClick: handleIndicatorClick
    };
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
;// CONCATENATED MODULE: ./modules/HomePageV2/hooks/useVisibilityObserver.ts


/**
 * Hook to detect when an element enters/exits the viewport using IntersectionObserver
 * @param options Configuration options for the observer
 * @returns Object with ref to attach to element and visibility state
 */ var useVisibilityObserver = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _threshold = options.threshold, threshold = _threshold === void 0 ? 0.1 : _threshold;
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var elementRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
            setIsVisible(entry.isIntersecting);
        }, {
            threshold: threshold
        });
        if (elementRef.current) {
            observer.observe(elementRef.current);
        }
        return function() {
            return observer.disconnect();
        };
    }, [
        threshold
    ]);
    return {
        elementRef: elementRef,
        isVisible: isVisible
    };
};

// EXTERNAL MODULE: ./modules/HomePageV2/sections/LifestyleSection/LifestyleSection.module.scss
var LifestyleSection_module = __webpack_require__(13449);
var LifestyleSection_module_default = /*#__PURE__*/__webpack_require__.n(LifestyleSection_module);
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/LifestyleSection/LifestyleSection.tsx















var LifestyleSection = function(param) {
    var HeadingComponent = param.headingLevel, doctorName = param.doctorName;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var _practitionerProfileUrl;
    var profileUrl = (_practitionerProfileUrl = appClientConfig/* appClientConfig.practitionerProfileUrl */.p.practitionerProfileUrl) !== null && _practitionerProfileUrl !== void 0 ? _practitionerProfileUrl : "";
    var ref = useVisibilityObserver({
        threshold: 0.2
    }), elementRef = ref.elementRef, isVisible = ref.isVisible;
    // we can extract this into a prop later
    var carouselImages = [
        DrDaveWork,
        DrDaveSurfing,
        DrDaveSurfsUp
    ];
    var currentIndex = useCarousel({
        carouselData: carouselImages,
        isVisible: isVisible,
        transitionDuration: 500,
        autoAdvanceInterval: 3000
    }).currentIndex;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionContainer_SectionContainer, {
        ref: elementRef,
        className: (LifestyleSection_module_default()).lifestyleSection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (LifestyleSection_module_default()).imageContainer,
                children: [
                    carouselImages.map(function(image, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: image.src,
                            "aria-hidden": "true",
                            layout: "fill",
                            objectFit: "cover",
                            priority: index === 0,
                            placeholder: "blur",
                            blurDataURL: image.blurDataURL,
                            sizes: "(max-width: 320px) 320px, (max-width: 599px) 100vw, (max-width: 959px) 50vw, 50vw",
                            className: (0,clsx_m/* default */.Z)((LifestyleSection_module_default()).lifestyleImage, index === currentIndex && (LifestyleSection_module_default()).visible)
                        }, image.src);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (LifestyleSection_module_default()).drNamePill,
                        children: doctorName
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (LifestyleSection_module_default()).contentContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeadingComponent, {
                        className: (LifestyleSection_module_default()).title,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Helping doctors"
                            }),
                            " live the lives they want"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (LifestyleSection_module_default()).description,
                        children: "Whether you’re after lifestyle flexibility, higher pay, or career progression, Medrecruit is here to help. As Australasia's largest medical recruitment agency, we simplify your career management, offering a free, end-to-end service for doctors."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Button/* default */.Z, {
                        className: (LifestyleSection_module_default()).joinUsButton,
                        href: "".concat(profileUrl, "/sign-up"),
                        onClick: function() {
                            return track("Click", {
                                action: "Lifestyle section - Register today",
                                "element text": "Register today",
                                "element type": "button"
                            });
                        },
                        trackFunction: function(eventProps) {
                            track("Click", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, eventProps), {
                                action: "Lifestyle section - Register today"
                            }));
                        },
                        children: "Register today"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./modules/HomePageV2/sections/PlacementTypeSection/PlacementTypeSection.module.scss
var PlacementTypeSection_module = __webpack_require__(97115);
var PlacementTypeSection_module_default = /*#__PURE__*/__webpack_require__.n(PlacementTypeSection_module);
// EXTERNAL MODULE: ./components/EngagementButtons/EngagementButtons.module.scss
var EngagementButtons_module = __webpack_require__(30606);
var EngagementButtons_module_default = /*#__PURE__*/__webpack_require__.n(EngagementButtons_module);
;// CONCATENATED MODULE: ./components/EngagementButtons/EngagementButtons.tsx







var EngagementButtons = function(param) {
    var className = param.className, trackAction = param.trackAction, _searchJobsUrl = param.searchJobsUrl, searchJobsUrl = _searchJobsUrl === void 0 ? "/jobs" : _searchJobsUrl;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var _practitionerProfileUrl;
    var profileUrl = (_practitionerProfileUrl = appClientConfig/* appClientConfig.practitionerProfileUrl */.p.practitionerProfileUrl) !== null && _practitionerProfileUrl !== void 0 ? _practitionerProfileUrl : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((EngagementButtons_module_default()).container, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "contained",
                className: classnames_default()((EngagementButtons_module_default()).button, (EngagementButtons_module_default()).joinButton),
                href: "".concat(profileUrl, "/sign-up"),
                onClick: function() {
                    return track("Click", {
                        action: "".concat(trackAction, " - join us"),
                        "element text": "Join us",
                        "element type": "button"
                    });
                },
                children: "Join us"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: searchJobsUrl,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    component: "a",
                    variant: "outlined",
                    className: classnames_default()((EngagementButtons_module_default()).button, (EngagementButtons_module_default()).searchButton),
                    onClick: function() {
                        return track("Click", {
                            action: "".concat(trackAction, " - search for jobs"),
                            "element text": "Search for jobs",
                            "element type": "button"
                        });
                    },
                    children: "Search for jobs"
                })
            })
        ]
    });
};
/* harmony default export */ var EngagementButtons_EngagementButtons = (EngagementButtons);

// EXTERNAL MODULE: ./components/TickList/index.ts + 2 modules
var TickList = __webpack_require__(77135);
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/PlacementTypeSection/assets/specialist-locum.png
/* harmony default export */ var specialist_locum = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/specialist-locum.e3ecc87d.png","height":370,"width":414,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAV1BMVEVMaXGch31lYVW8qJv54c8fHh6ymIu2u7KEc2UHCg8ABguznpDJr5/q2LuYgnBsX1JkV1BCOTp1aVvGmIVrXlKIbGESFBnguaulhXbCmYuQb2NhRj1fQzddtrJSAAAAFnRSTlMAjx/MIf7uBc/+W6HWD9uT1f7vhTnxtqDKIgAAAAlwSFlzAAALEwAACxMBAJqcGAAAAD1JREFUCJkVxkcWgCAMQMGvggk2rAmW+5/Tx6wGCJ22gDB6ydRN/mjNvNyfCsiw+ruf0JhtMV6B3ixZKscPPZICbPc+5r8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./modules/HomePageV2/sections/PlacementTypeSection/components/Content.module.scss
var Content_module = __webpack_require__(1406);
var Content_module_default = /*#__PURE__*/__webpack_require__.n(Content_module);
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/PlacementTypeSection/components/LocumContent.tsx






var LocumContent = function(param) {
    var isDesktop = param.isDesktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Content_module_default()).contentContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Content_module_default()).contentText,
                children: "Flexibility, higher pay, and the chance to explore diverse healthcare settings across Australia and New Zealand. With locuming, you choose when and where you work, and we’ll handle the rest."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TickList/* TickList */.l, {
                items: [
                    "Boost income with competitive rates",
                    "Work across diverse settings",
                    "Travel and accommodation covered", 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EngagementButtons_EngagementButtons, {
                trackAction: "Placement section - Locum",
                searchJobsUrl: "/jobs/list?workType=Locum&page=1"
            }),
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Content_module_default()).imageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: specialist_locum,
                    priority: false,
                    alt: "",
                    "aria-hidden": true,
                    width: 414,
                    height: 370
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/EngagementButtons/index.ts


;// CONCATENATED MODULE: ./modules/HomePageV2/sections/PlacementTypeSection/assets/specialist-permanent.png
/* harmony default export */ var specialist_permanent = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/specialist-permanent.0d32bd1f.png","height":396,"width":417,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAVFBMVEVuWlMeHiA5Mi6cbl+FZ1vOrJ8HCQsYGx4jISEfHRpOQz0ZGRuKd29DMSmEbWRdTUcXGh0AAAAlJykIDREVFhmVcmXWuKymgHC3kYd3XFKBZV1ZTEnPl/QSAAAAFHRSTlMBn3Ffd7z++VYnndqZ+P25ww899tUnpPoAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA9SURBVAiZY2Bg4ORiYgADHjFRDjCDVUycBcKQEGUGM1ikeDlBtCC/JBs3BwODELs0Hxs7OyODgAi7CAgAADw+AizMH9+HAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/PlacementTypeSection/components/PermanentContent.tsx






var PermanentContent = function(param) {
    var isDesktop = param.isDesktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Content_module_default()).contentContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (Content_module_default()).contentText,
                children: "Enjoy stability, steady income, and meaningful team connections in hospitals and clinics across Australia and New Zealand. Whether you're looking to stay local or relocate long-term, we’ll connect you with roles that support your goals."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TickList/* TickList */.l, {
                items: [
                    "Predictable rosters and income",
                    "Build long-term team relationships",
                    "Clear pathways to develop your skills", 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EngagementButtons_EngagementButtons, {
                trackAction: "Placement section - Permanent",
                searchJobsUrl: "/jobs/list?workType=Permanent&page=1"
            }),
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Content_module_default()).imageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: specialist_permanent,
                    priority: false,
                    alt: "",
                    "aria-hidden": true,
                    width: 417,
                    height: 396
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./modules/HomePageV2/sections/PlacementTypeSection/PlacementTypeSection.tsx







var PlacementTypeSection = function() {
    var isDesktop = (0,useMediaQuery/* default */.Z)("(min-width: 1024px)");
    var titleLocum = /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: (PlacementTypeSection_module_default()).accordionTitle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: "Locum work?"
        })
    });
    var titlePermanent = /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: (PlacementTypeSection_module_default()).accordionTitle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: "Permanent work?"
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionContainer_SectionContainer, {
        className: (PlacementTypeSection_module_default()).placementSectionContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                className: (PlacementTypeSection_module_default()).sectionTitle,
                children: [
                    "Are you ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "interested in..."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion_Accordion, {
                title: titleLocum,
                variant: "secondary",
                testId: "locum-accordion",
                top: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocumContent, {
                    isDesktop: isDesktop
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion_Accordion, {
                title: titlePermanent,
                variant: "secondary",
                testId: "permanent-accordion",
                bottom: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PermanentContent, {
                    isDesktop: isDesktop
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./modules/HomePageV2/hooks/index.ts



// EXTERNAL MODULE: ./modules/HomePageV2/sections/Testimonials/Testimonials.module.scss
var Testimonials_module = __webpack_require__(21192);
var Testimonials_module_default = /*#__PURE__*/__webpack_require__.n(Testimonials_module);
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/Testimonials/Testimonials.tsx





var longTextThreshold = 100;
// TODO: Refactor this into a Carousel component when we need more than one carousel in the app.
var Testimonials = function(param) {
    var testimonials = param.testimonials, _darkMode = param.darkMode, darkMode = _darkMode === void 0 ? false : _darkMode;
    var ref = useVisibilityObserver({
        threshold: 0.1
    }), elementRef = ref.elementRef, isVisible = ref.isVisible;
    var ref1 = useCarousel({
        carouselData: testimonials,
        isVisible: isVisible,
        autoAdvanceInterval: 7000
    }), currentIndex = ref1.currentIndex, currentItem = ref1.currentItem, isTransitioning = ref1.isTransitioning, animationKey = ref1.animationKey, handleIndicatorClick = ref1.handleIndicatorClick;
    var isLongText = currentItem.text.length > longTextThreshold;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionContainer_SectionContainer, {
        ref: elementRef,
        className: classnames_default()((Testimonials_module_default()).testimonialsContainer, darkMode && (Testimonials_module_default()).darkMode),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Testimonials_module_default()).testimonialContent, isTransitioning && (Testimonials_module_default()).slideOut),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Testimonials_module_default()).iconContainer,
                        children: currentItem.svgIcon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: classnames_default()((Testimonials_module_default()).testimonialsText, isLongText && (Testimonials_module_default()).longText),
                        children: currentItem.text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Testimonials_module_default()).testimonialAuthorContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (Testimonials_module_default()).testimonialAuthor,
                            children: currentItem.author
                        })
                    })
                ]
            }, currentIndex),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Testimonials_module_default()).indicators,
                children: testimonials.map(function(_, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: classnames_default()((Testimonials_module_default()).indicator, index === currentIndex && (Testimonials_module_default()).active, index < currentIndex && (Testimonials_module_default()).completed),
                        onClick: function() {
                            return handleIndicatorClick(index);
                        },
                        "aria-label": "View testimonial ".concat(index + 1)
                    }, "".concat(index, "-").concat(animationKey));
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./modules/HomePageV2/assets/Sean.png
/* harmony default export */ var Sean = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/Sean.58053976.png","height":286,"width":365,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAPFBMVEVMaXExMzYAEiBoVk4gJyyNeGqjbVt/bWGqgWrKppNoW1V9Xkyffm1TQjogJCjnwKuziXiUdWQ9OTmGZVeUzGS1AAAADnRSTlMAiSP8SuMVYtrEqad68Z8+ygEAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAuSURBVAiZY2BgYGdlZwADTn4OKEOAgw3M4BHmBtNMXIK8LAwMDCx8Qsx8fIwMABWHAPdtHgR6AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./modules/HomePageV2/assets/SolutionSpecialist-1.png
/* harmony default export */ var SolutionSpecialist_1 = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/SolutionSpecialist-1.6d6bf04d.png","height":284,"width":350,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAARVBMVEWMgHlsUEAFEBnDl34sKi8jISZTNScyMTdMaXErJCVLOjUrLTAnLDURERMOCgoOERMfHByAZlhhUkkeGhpBMCg5LCa1g2kIb7MBAAAAE3RSTlME9Bz++/7+/QBoTrwmuP5T1OvKo1pvjwAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAADdJREFUCJkdxkESgCAMA8AglKSgoID+/6nMuKeFMOLbBeh4Yrj+hC/fEOQzt1mEk2aWquCJJJdvKpwBmfPo5c8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./modules/HomePageV2/assets/SolutionSpecialist-2.png
/* harmony default export */ var SolutionSpecialist_2 = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/SolutionSpecialist-2.dffc817b.png","height":286,"width":392,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAPFBMVEXCso/dtZyQYkskJSogHyBURTiiiXR1ZFZMPDAlIyY3MCt+XEcZGhuogmolJSWrjHVIPDbJsJ6YblnGnogavZ2FAAAAD3RSTlMBXWPN/hc6njsJifao6/CpgRmbAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAMElEQVQImWNgYGBgZ2cAAzZBfg4wg1FYiAkixMvNCqI4ufgFeFgZGDiZBfhZWPg4ABZ4AQ7DzpZ1AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./modules/HomePageV2/assets/SolutionSpecialist-3.png
/* harmony default export */ var SolutionSpecialist_3 = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/SolutionSpecialist-3.99955fe6.png","height":290,"width":315,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAS1BMVEVMaXFtXVFDMygkJytWSkNeUEMtJRs2KiBIQjlvXk96aVw+MiiVh3xaTEF5ZFd2Yk+KdF/AoIt9ZlaYd2VNOyrNppeGcWPPtqhsUkCa2YAmAAAAFHRSTlMAq69M/gtp/RabnucrZMo9L/zg/nIgQMUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAA6SURBVAiZHcZZFkAwEAXRQngdU9Ad7H+lTtTPLcC6PNKan3v6Z6/eN+2qvhhwhL9agazTtUEJpRQaPjLbAdxdHYUKAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./modules/HomePageV2/assets/SolutionSpecialist-4.png
/* harmony default export */ var SolutionSpecialist_4 = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/SolutionSpecialist-4.4f891afe.png","height":282,"width":378,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAPFBMVEVMaXFSQDhFOC/Bw8XGpJRoVEoaGxjR1tnY4eduZluepqu1o5pvVUjCnItWQjfM0dXSqZWkfWuBZlvc4eau8nCaAAAAD3RSTlMAqXT8RpMTmEsz0+161FKWkDpWAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAL0lEQVQImR3GxxEAIAzAMNM7oey/K0f8sQCCifzK2lbh1+4Kxpn63E7NQLriRNIDF3EBH/m7qqMAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./modules/HomePageV2/assets/SophieSteenberg.png
/* harmony default export */ var SophieSteenberg = ({"src":"https://cdn.medrecruit.medworld.com/1e0f9467335129100310346fbf703c55eee05428/_next/static/media/SophieSteenberg.0d0ee106.png","height":286,"width":347,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAATlBMVEVMaXGQfW3MtqWYhWr////oyaW6r5qYcWCHeGbGp5NRS0Ggim+Sg2wAAABHQjp5cWWsl4DSo5ALERirjXbUqZzRs5y4moLTupi7j3yZinZ9o/RdAAAAF3RSTlMAiIW/BfwM/mfLdtRUHfu32f2R/////nvEECoAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAA5SURBVAiZY2BgYGPkYAADJlFhCItTRIwZRLNwikhwgxkC7OxiPAwMvPyi7ILiwlwMQpKswiKs4nwALQ8B/vii37kAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./modules/HomePageV2/staticData/whyJoinMedrecruitCardData.ts






var whyJoinMedrecruitCardData = [
    {
        description: "Exclusive roles you won’t find elsewhere",
        solutionSpecialistImageSrc: SolutionSpecialist_1.src,
        width: 175,
        height: 142
    },
    {
        description: "We negotiate the best rates for you",
        solutionSpecialistImageSrc: SolutionSpecialist_2.src,
        width: 196,
        height: 143
    },
    {
        description: "On every recruitment panel across Australia and NZ",
        solutionSpecialistImageSrc: SolutionSpecialist_3.src,
        width: 157,
        height: 145
    },
    {
        description: "1:1 recruiter dedicated to your grade & specialty",
        solutionSpecialistImageSrc: SolutionSpecialist_4.src,
        width: 189,
        height: 141
    },
    {
        description: "Free, end-to-end support that saves you time",
        solutionSpecialistImageSrc: SophieSteenberg.src,
        width: 173,
        height: 143
    },
    {
        description: "Access to Australasia’s largest doctor job network",
        solutionSpecialistImageSrc: Sean.src,
        width: 182,
        height: 143
    }, 
];

// EXTERNAL MODULE: ./modules/HomePageV2/sections/WhyMedrecruit/WhyMedrecruit.module.scss
var WhyMedrecruit_module = __webpack_require__(27621);
var WhyMedrecruit_module_default = /*#__PURE__*/__webpack_require__.n(WhyMedrecruit_module);
// EXTERNAL MODULE: ./modules/HomePageV2/sections/WhyMedrecruit/components/WhyJoinMedrecruitCard/WhyJoinMedrecruitCard.module.scss
var WhyJoinMedrecruitCard_module = __webpack_require__(13546);
var WhyJoinMedrecruitCard_module_default = /*#__PURE__*/__webpack_require__.n(WhyJoinMedrecruitCard_module);
;// CONCATENATED MODULE: ./modules/HomePageV2/sections/WhyMedrecruit/components/WhyJoinMedrecruitCard/WhyJoinMedrecruitCard.tsx






var WhyJoinMedrecruitCard = function(param) {
    var solutionSpecialistImageSrc = param.solutionSpecialistImageSrc, description = param.description, width = param.width, height = param.height;
    var isDesktop = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.up("md");
    });
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var _practitionerProfileUrl;
    var profileUrl = (_practitionerProfileUrl = appClientConfig/* appClientConfig.practitionerProfileUrl */.p.practitionerProfileUrl) !== null && _practitionerProfileUrl !== void 0 ? _practitionerProfileUrl : "";
    var signUpUrl = "".concat(profileUrl, "/sign-up");
    var handleCardClick = function() {
        track("Click", {
            action: "Why join Medrecruit card",
            "element text": "".concat(description),
            "element type": "card"
        });
    };
    return isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        href: signUpUrl,
        className: (WhyJoinMedrecruitCard_module_default()).whyJoinMedrecruitCard,
        onClick: handleCardClick,
        onKeyDown: function(e) {
            if (e.key === "Enter" || e.key === " ") {
                handleCardClick();
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (WhyJoinMedrecruitCard_module_default()).imageWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: solutionSpecialistImageSrc,
                    alt: "",
                    "aria-hidden": true,
                    width: width,
                    height: height,
                    className: (WhyJoinMedrecruitCard_module_default()).image
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (WhyJoinMedrecruitCard_module_default()).description,
                children: description
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (WhyJoinMedrecruitCard_module_default()).whyJoinMedrecruitCard,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: (WhyJoinMedrecruitCard_module_default()).description,
            children: description
        })
    });
};

;// CONCATENATED MODULE: ./modules/HomePageV2/sections/WhyMedrecruit/WhyMedrecruit.tsx






var WhyMedrecruit = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionContainer_SectionContainer, {
        className: (WhyMedrecruit_module_default()).whyMedrecruitContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                children: [
                    "Why doctors ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "choose Medrecruit"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (WhyMedrecruit_module_default()).whyJoinMedrecruitCards,
                children: whyJoinMedrecruitCardData.map(function(card) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyJoinMedrecruitCard, {
                        description: card.description,
                        solutionSpecialistImageSrc: card.solutionSpecialistImageSrc,
                        width: card.width,
                        height: card.height
                    }, card.description);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EngagementButtons_EngagementButtons, {
                trackAction: "Why join Medrecruit",
                className: (WhyMedrecruit_module_default()).buttonContainer
            })
        ]
    });
};

;// CONCATENATED MODULE: ./modules/HomePageV2/assets/RegistrarF.svg
var RegistrarF_path, RegistrarF_path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function RegistrarF_extends() { return RegistrarF_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, RegistrarF_extends.apply(null, arguments); }

var SvgRegistrarF = function SvgRegistrarF(props) {
  return /*#__PURE__*/react.createElement("svg", RegistrarF_extends({
    width: 70,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), RegistrarF_path || (RegistrarF_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.996 0c19.325 0 34.997 15.672 34.997 34.996 0 19.325-15.672 34.997-34.997 34.997C15.672 69.993 0 54.32 0 34.996 0 15.672 15.672 0 34.996 0Z",
    fill: "#247EFF"
  })), RegistrarF_path2 || (RegistrarF_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.996 0v69.993C15.672 69.993 0 54.32 0 34.996 0 15.672 15.672 0 34.996 0Z",
    fill: "#004AB3"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m29.303 33.45 3.314.21c2.71 0 5.341-.037 8.073-.21l.56 4.3c.296 2.236.957 3.76 3.3 4.069 5.917.776 9.584 1.761 12.179 5.593 1.998 2.94 3.666 7.419 3.178 10.985a11.75 11.75 0 0 1-.295 1.466c-6.32 6.262-15.018 10.13-24.616 10.13-9.597 0-18.296-3.868-24.615-10.13-.122-.46-.223-.949-.295-1.466-.489-3.566 1.18-8.045 3.178-10.985 2.602-3.832 6.269-4.817 12.178-5.593 2.344-.31 3.005-1.833 3.3-4.07l.56-4.298Z",
    fill: "#ECBB8E"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.79 39.626c.439 1.251 1.107 1.977 2.76 2.2 5.917.776 9.584 1.761 12.179 5.593 1.998 2.94 3.666 7.42 3.178 10.985a11.75 11.75 0 0 1-.295 1.467C53.292 66.132 44.594 70 34.996 70 25.4 70 16.7 66.131 10.381 59.87c-.122-.46-.223-.95-.295-1.467-.489-3.566 1.18-8.045 3.178-10.985 2.602-3.832 6.269-4.816 12.178-5.593 1.495-.201 2.3-.891 2.775-1.941l6.708 16.233 6.872-16.485-.007-.007Z",
    fill: "#5B9FFF"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.42 41.934c5.407.769 8.843 1.833 11.309 5.47 1.998 2.941 3.666 7.42 3.178 10.986a11.752 11.752 0 0 1-.295 1.466c-6.27 6.211-14.882 10.065-24.386 10.122l3.502-6.52 6.692-21.531v.007Zm-35.039 17.93c-.122-.46-.223-.95-.295-1.467-.489-3.566 1.18-8.045 3.178-10.985 2.494-3.674 5.967-4.723 11.46-5.493l6.361 21.424 3.653 6.65A34.873 34.873 0 0 1 10.38 59.87v-.008Z",
    fill: "#DCE7ED"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.087 66.175-.209-4.989c-.28-6.686-.15-6.535-.89 0l-.468 4.134a41.1 41.1 0 0 0 1.567.855ZM50.949 66.154l.208-4.968c.274-6.686.151-6.535.87 0l.453 4.127c-.503.287-1.013.568-1.531.834v.007Z",
    fill: "#BBCED6"
  })), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.226 29.67c1.05 2.853 2.638 5.032 4.622 6.707 3.66 3.105 4.846 3.084 8.49-.03 2.006-1.71 3.617-3.939 4.66-6.872.236.338.675.18 1.049-.1.431-.324.726-.748.97-1.251.669-1.366.97-3.279.28-4.163a1.095 1.095 0 0 0-.876-.438c.273-1.107.59-2.2.913-3.473 1.624-6.484-3.94-12.027-11.338-12.962-7.023.705-12.552 6.506-11.171 12.962.273 1.294.604 2.387.891 3.501-.28.05-.54.187-.74.417-.77.885-.432 2.797.316 4.163.273.503.604.927 1.093 1.25.28.188.59.317.84.288Z",
    fill: "#FBD9AB"
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m25.981 41.309 2.229-1.798 4.91 12.193-10.086 1.574 2.947-11.97Z",
    fill: "#F6C9D4"
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m43.882 41.309-2.229-1.798-4.91 12.193 10.087 1.574-2.948-11.97Z",
    fill: "#5B9FFF"
  })), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m24.155 57.628 2.861-4.055-4.63 1.15-2.544-11.934 6.262-1.48 8.734 28.677c-.201 0-.395 0-.596-.008l-2.725-1.71L24.14 57.62l.014.008Z",
    fill: "#F7FCFE"
  })), _path11 || (_path11 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m45.837 57.628-2.86-4.055 4.629 1.15 2.545-11.934-6.262-1.48-8.735 28.677c.202 0 .396 0 .597-.008l2.725-1.71 7.376-10.648-.014.008Z",
    fill: "#FBFDFF"
  })), _path12 || (_path12 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.314 54.673a4.946 4.946 0 1 1 0 9.891 4.946 4.946 0 0 1 0-9.891Z",
    fill: "#58595B"
  })), _path13 || (_path13 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.314 56.039a3.58 3.58 0 0 1 3.58 3.58 3.587 3.587 0 0 1-3.58 3.587 3.582 3.582 0 0 1-3.58-3.587 3.576 3.576 0 0 1 3.58-3.58Z",
    fill: "#C4C6C8"
  })), _path14 || (_path14 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.675 44.17c-.302 2.674-.15 6.182.51 10.927l1.596-.223c-.64-4.608-.783-7.98-.503-10.532.108-.941.273-1.754.496-2.48l-1.768.417c-.137.59-.252 1.2-.331 1.89Z",
    fill: "#58595B"
  })), _path15 || (_path15 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.059 43.242c.324 2.48.259 5.723-.237 10.101l1.639.208c.51-4.514.568-7.907.23-10.539-.014-.115-.036-.223-.05-.338l-1.74-.41c.057.317.115.64.165.985l-.007-.007Z",
    fill: "#3E4143"
  })), _path16 || (_path16 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.46 54.472c-.77-.877-1.654-1.352-2.56-1.402-.92-.043-1.826.352-2.624 1.215-1.653 1.776-2.919 5.744-2.854 12.128l1.646-.015c-.064-5.866 1-9.403 2.387-10.884.453-.489.935-.719 1.38-.69.468.022.957.31 1.424.848 1.337 1.524 2.343 4.795 2.279 9.62a34.174 34.174 0 0 0 1.625-1.007c-.094-4.767-1.223-8.117-2.704-9.806v-.007Z",
    fill: "#3E4143"
  })), _path17 || (_path17 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m45.061 65.579-1.646-.014a41.6 41.6 0 0 0 .093 3.378c.54-.136 1.079-.28 1.61-.445a42.15 42.15 0 0 1-.057-2.926v.007Z",
    fill: "#A7A9AC"
  })), _path18 || (_path18 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m29.303 33.45 3.314.21c.798 0 1.589 0 2.38-.015v36.34c-9.598 0-18.297-3.867-24.616-10.129-.122-.46-.223-.949-.295-1.466-.489-3.566 1.18-8.045 3.178-10.985 2.602-3.832 6.269-4.817 12.178-5.593 2.344-.31 3.005-1.834 3.3-4.07l.56-4.298v.007Z",
    fill: "#E5A877"
  })), _path19 || (_path19 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.996 69.993c-9.597 0-18.296-3.868-24.615-10.13a12.3 12.3 0 0 1-.295-1.466c-.489-3.566 1.18-8.045 3.178-10.985 2.602-3.832 6.269-4.817 12.178-5.593 1.495-.202 2.3-.892 2.775-1.941l6.708 16.233.079-.187v14.069h-.008Z",
    fill: "#247EFF"
  })), _path20 || (_path20 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.381 59.863c-.122-.46-.223-.949-.295-1.466-.489-3.566 1.18-8.045 3.178-10.985 2.494-3.674 5.967-4.723 11.46-5.493l6.361 21.424 3.653 6.65A34.873 34.873 0 0 1 10.38 59.87v-.008Z",
    fill: "#D3E1E9"
  })), _path21 || (_path21 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.087 66.175-.209-4.989c-.28-6.686-.15-6.535-.89 0l-.468 4.134a41.1 41.1 0 0 0 1.567.855Z",
    fill: "#A4B7C0"
  })), _path22 || (_path22 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.226 29.67c1.05 2.853 2.638 5.032 4.622 6.707 1.776 1.51 2.97 2.279 4.148 2.315V7.088c-7.023.705-12.552 6.506-11.171 12.962.273 1.294.604 2.387.891 3.501-.28.05-.54.187-.74.417-.77.885-.432 2.797.316 4.163.273.503.604.927 1.093 1.25.28.188.59.317.84.288Z",
    fill: "#F7C996"
  })), _path23 || (_path23 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m25.981 41.309 2.229-1.798 4.91 12.193-10.086 1.574 2.947-11.97Z",
    fill: "#247EFF"
  })), _path24 || (_path24 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m24.155 57.628 2.861-4.055-4.63 1.15-2.544-11.934 6.262-1.48 8.734 28.677c-.201 0-.395 0-.596-.008l-2.725-1.71L24.14 57.62l.014.008Z",
    fill: "#F7FCFE"
  })), _path25 || (_path25 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.314 54.673a4.946 4.946 0 1 1 0 9.891 4.946 4.946 0 0 1 0-9.891Z",
    fill: "#262220"
  })), _path26 || (_path26 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.314 56.039a3.58 3.58 0 0 1 3.58 3.58 3.587 3.587 0 0 1-3.58 3.587 3.582 3.582 0 0 1-3.58-3.587 3.576 3.576 0 0 1 3.58-3.58Z",
    fill: "#939598"
  })), _path27 || (_path27 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.675 44.17c-.302 2.674-.15 6.182.51 10.927l1.596-.223c-.64-4.608-.783-7.98-.503-10.532.108-.941.273-1.754.496-2.48l-1.768.417c-.137.59-.252 1.2-.331 1.89Z",
    fill: "#262220"
  })), _path28 || (_path28 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.247 36.887c-1.61-8.835-6.334-7.793-5.45-18.188.51-6.018 5.09-10.77 9.39-12.229 2.307-.783 5.161-.841 7.612-.108 5.471 1.632 8.563 6.427 9.504 11.388.41 2.113-.028 4.608-.337 6.549-.633 4.033-4.228 10.014-5.795 13.264 6.65-13.796-7.994-22.76-7.556-26.78-2.868 8.29-10.41 6.212-7.39 26.104h.022Z",
    fill: "#FFFAE7"
  })), _path29 || (_path29 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.247 36.887c-1.61-8.835-6.334-7.793-5.45-18.188.51-6.018 5.09-10.77 9.39-12.229 1.164-.395 2.472-.604 3.802-.625v6.448c-.273-.568-.41-1.07-.36-1.524-2.868 8.29-10.409 6.212-7.39 26.104l.008.014Z",
    fill: "#F7E2BA"
  })));
};
/* harmony default export */ var RegistrarF = (SvgRegistrarF);
;// CONCATENATED MODULE: ./modules/HomePageV2/assets/RegistrarM.svg
var RegistrarM_path, RegistrarM_path2, RegistrarM_path3, RegistrarM_path4, RegistrarM_path5, RegistrarM_path6, RegistrarM_path7, RegistrarM_path8, RegistrarM_path9, RegistrarM_path10, RegistrarM_path11, RegistrarM_path12, RegistrarM_path13, RegistrarM_path14, RegistrarM_path15, RegistrarM_path16, RegistrarM_path17;
function RegistrarM_extends() { return RegistrarM_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, RegistrarM_extends.apply(null, arguments); }

var SvgRegistrarM = function SvgRegistrarM(props) {
  return /*#__PURE__*/react.createElement("svg", RegistrarM_extends({
    width: 70,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), RegistrarM_path || (RegistrarM_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 0c19.326 0 35 15.674 35 35S54.326 70 35 70 0 54.326 0 35 15.674 0 35 0Z",
    fill: "#0A1B57"
  })), RegistrarM_path2 || (RegistrarM_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 0v70C15.674 70 0 54.326 0 35S15.674 0 35 0Z",
    fill: "#247EFF"
  })), RegistrarM_path3 || (RegistrarM_path3 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.362 48.481a14.195 14.195 0 0 0-1.502 5.903C12.136 63.795 22.842 70 35 70c12.158 0 22.864-6.205 29.14-15.616a14.312 14.312 0 0 0-1.51-5.903c-4.716-9.297-17.126-7.758-18.729-10.145-1.244-1.855-.503-7.55-.59-9.016-5.809.554-10.763.431-16.572-.122-.08 1.467.597 7.283-.647 9.138-1.604 2.387-14.013.849-18.73 10.145Z",
    fill: "#865E45"
  })), RegistrarM_path4 || (RegistrarM_path4 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.362 48.481a14.195 14.195 0 0 0-1.502 5.903C12.136 63.795 22.842 70 35 70V29.672c-2.682-.028-5.364-.2-8.254-.474-.079 1.467.597 7.283-.647 9.138-1.603 2.387-14.013.849-18.73 10.145h-.007Z",
    fill: "#6E4936"
  })), RegistrarM_path5 || (RegistrarM_path5 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.82 20.908c-.374-.446-.906-.568-1.46-.496a56.11 56.11 0 0 0 .022-1.546c0-2.977-.008-6.629-1.05-8.707-.755-1.524-1.913-2.516-3.272-3.257-5.227-2.825-8.893-2.825-14.12 0-1.366.74-2.517 1.733-3.272 3.257-1.042 2.085-1.05 5.738-1.05 8.707 0 .51.008 1.028.022 1.546-.553-.072-1.085.05-1.46.496-.862 1.035-.481 3.278.36 4.875.31.59.676 1.085 1.222 1.46.223.157.46.272.676.323.367 1.69.877 3.278 1.575 4.702.963 1.97 2.279 3.61 4.055 4.695 2.782 1.704 7.103 1.704 9.886 0 1.776-1.086 3.091-2.725 4.055-4.695.697-1.424 1.208-3.02 1.575-4.702.222-.05.452-.166.675-.324.547-.374.913-.877 1.223-1.46.84-1.596 1.215-3.839.352-4.874h-.015Z",
    fill: "#AB7D5D"
  })), RegistrarM_path6 || (RegistrarM_path6 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.613 5.335c-1.366-1.33-3.364-2.1-5.895-2.524-.842-.144-4.66-.13-5.536.022-2.48.424-4.437 1.193-5.788 2.502-3.372 3.271-3.566 9.117-3.013 15.566 2.006-4.02 5.12-5.766 8.858-6.248.892-.115 4.537-.122 5.378-.022 3.803.453 6.981 2.193 9.023 6.27.547-6.45.353-12.295-3.02-15.566h-.007Z",
    fill: "#79B0FF"
  })), RegistrarM_path7 || (RegistrarM_path7 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 4.774c-2.222 0-4.45.705-7.06 2.114-1.366.74-2.517 1.733-3.272 3.257-1.042 2.085-1.05 5.737-1.05 8.707 0 .51.008 1.028.022 1.546-.553-.072-1.085.05-1.46.496-.862 1.035-.481 3.278.36 4.874.31.59.676 1.086 1.222 1.46a2 2 0 0 0 .676.323c.367 1.69.877 3.279 1.575 4.703.963 1.97 2.279 3.609 4.055 4.694 1.387.856 3.163 1.28 4.946 1.28V4.767L35 4.774Z",
    fill: "#996949"
  })), RegistrarM_path8 || (RegistrarM_path8 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 2.718c-1.18 0-2.38.043-2.826.122-2.48.424-4.436 1.194-5.787 2.502-3.372 3.271-3.567 9.117-3.013 15.566 2.006-4.02 5.12-5.766 8.858-6.248.453-.058 1.625-.086 2.768-.093V2.717Z",
    fill: "#004AB3"
  })), RegistrarM_path9 || (RegistrarM_path9 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.068 37.567c-1.769-1.028-3.085-2.574-4.048-4.436-.626-1.208-1.1-3.193-1.452-4.602C27.235 25.502 30.93 24.28 35 24.28c4.07 0 7.758 1.222 10.432 4.25-.352 1.416-.826 3.393-1.452 4.6-.963 1.863-2.272 3.409-4.04 4.437-2.776 1.61-7.09 1.61-9.865 0h-.007Z",
    fill: "#fff"
  })), RegistrarM_path10 || (RegistrarM_path10 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.068 37.567c-1.769-1.028-3.085-2.574-4.048-4.436-.626-1.208-1.1-3.193-1.452-4.602C27.235 25.502 30.93 24.28 35 24.28v14.487c-1.769 0-3.544-.402-4.932-1.207v.007Z",
    fill: "#DDEAF1"
  })), RegistrarM_path11 || (RegistrarM_path11 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.362 48.48a14.195 14.195 0 0 0-1.502 5.904C12.136 63.795 22.842 70 35 70c12.158 0 22.864-6.205 29.14-15.616a14.312 14.312 0 0 0-1.51-5.903c-3.587-7.068-11.618-7.873-15.968-8.901-1.129 3.731-5.745 6.528-11.274 6.528-5.529 0-10.295-2.89-11.324-6.715-4.112 1.143-12.905 1.603-16.702 9.088Z",
    fill: "#E8EDF0"
  })), RegistrarM_path12 || (RegistrarM_path12 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.072 39.386c-4.113 1.143-12.906 1.603-16.702 9.088a14.195 14.195 0 0 0-1.503 5.903c5.99 8.987 16.019 15.04 27.494 15.573-1.222-4.012-9.174-30.154-9.282-30.571l-.008.007Z",
    fill: "#6BC7B8"
  })), RegistrarM_path13 || (RegistrarM_path13 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.928 39.386c4.113 1.143 12.906 1.603 16.702 9.088a14.194 14.194 0 0 1 1.503 5.903c-5.989 8.987-16.019 15.04-27.494 15.573 1.215-4.005 9.174-30.154 9.282-30.571l.008.007Z",
    fill: "#79B0FF"
  })), RegistrarM_path14 || (RegistrarM_path14 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.362 48.48a14.195 14.195 0 0 0-1.502 5.904C12.136 63.795 22.842 70 35 70V46.101c-5.436-.13-9.922-2.977-10.936-6.708-4.112 1.143-12.905 1.603-16.702 9.088Z",
    fill: "#D4DDE2"
  })), RegistrarM_path15 || (RegistrarM_path15 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.072 39.386c-4.113 1.143-12.906 1.603-16.702 9.088a14.195 14.195 0 0 0-1.503 5.903c5.99 8.987 16.019 15.04 27.494 15.573-1.222-4.012-9.174-30.154-9.282-30.571l-.008.007Z",
    fill: "#004AB3"
  })), RegistrarM_path16 || (RegistrarM_path16 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.804 63.587c-.266-6.112-.158-6.176-.806-.59.267.201.533.395.806.59Z",
    fill: "#21564F"
  })), RegistrarM_path17 || (RegistrarM_path17 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.196 63.587c.266-6.112.166-6.176.805-.59a32.99 32.99 0 0 1-.805.59Z",
    fill: "#2A7269"
  })));
};
/* harmony default export */ var RegistrarM = (SvgRegistrarM);
;// CONCATENATED MODULE: ./modules/HomePageV2/assets/SeniorMandF.svg
var SeniorMandF_path, SeniorMandF_path2, SeniorMandF_path3, SeniorMandF_path4, SeniorMandF_path5, SeniorMandF_path6, SeniorMandF_path7, SeniorMandF_path8, SeniorMandF_path9, SeniorMandF_path10, SeniorMandF_path11, SeniorMandF_path12, SeniorMandF_path13, SeniorMandF_path14, SeniorMandF_path15, SeniorMandF_path16, SeniorMandF_path17, SeniorMandF_path18, SeniorMandF_path19, SeniorMandF_path20, SeniorMandF_path21, SeniorMandF_path22, SeniorMandF_path23, SeniorMandF_path24, SeniorMandF_path25, SeniorMandF_path26, SeniorMandF_path27, SeniorMandF_path28, SeniorMandF_path29, _path30;
function SeniorMandF_extends() { return SeniorMandF_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, SeniorMandF_extends.apply(null, arguments); }

var SvgSeniorMandF = function SvgSeniorMandF(props) {
  return /*#__PURE__*/react.createElement("svg", SeniorMandF_extends({
    width: 70,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), SeniorMandF_path || (SeniorMandF_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.996 0c19.325 0 34.997 15.672 34.997 34.996 0 19.325-15.672 34.997-34.997 34.997C15.672 69.993 0 54.32 0 34.996 0 15.672 15.672 0 34.996 0Z",
    fill: "#5B9FFF"
  })), SeniorMandF_path2 || (SeniorMandF_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.996 0v69.993C15.672 69.993 0 54.32 0 34.996 0 15.672 15.672 0 34.996 0Z",
    fill: "#0F68EF"
  })), SeniorMandF_path3 || (SeniorMandF_path3 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.858 66.125c-.54.23-1.107.446-1.697.647l.244-5.737c.274-6.441.151-6.297.87 0l.583 5.09Z",
    fill: "#AFC6D1"
  })), SeniorMandF_path4 || (SeniorMandF_path4 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.003 29C26.688 29 24 33.25 24 38.5s2.688 9.5 6.003 9.5S36 43.75 36 38.5 33.312 29 30.003 29Z",
    fill: "#CBCCCC"
  })), SeniorMandF_path5 || (SeniorMandF_path5 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m29.296 34.313 3.314.202c2.71 0 5.341-.036 8.073-.202l.568 4.149c.295 2.156.956 3.623 3.3 3.918 5.916.747 9.583 1.696 12.178 5.384 1.999 2.833 3.666 7.146 3.178 10.582a10.583 10.583 0 0 1-.36 1.625c-5.744 5.658-13.429 9.346-21.97 9.971a62.478 62.478 0 0 1-5.19 0c-8.534-.625-16.219-4.313-21.956-9.97a11.507 11.507 0 0 1-.36-1.626c-.488-3.436 1.18-7.75 3.178-10.582 2.603-3.688 6.27-4.637 12.186-5.384 2.344-.295 3.005-1.769 3.3-3.918l.56-4.149Z",
    fill: "#E7C09A"
  })), SeniorMandF_path6 || (SeniorMandF_path6 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.783 40.259c.438 1.208 1.107 1.905 2.76 2.113 5.917.748 9.584 1.697 12.179 5.385 1.998 2.833 3.666 7.146 3.177 10.582a10.594 10.594 0 0 1-.359 1.625c-5.744 5.658-13.43 9.346-21.963 9.971a62.565 62.565 0 0 1-5.19 0c-8.534-.625-16.219-4.32-21.956-9.971a11.505 11.505 0 0 1-.36-1.625c-.488-3.436 1.18-7.75 3.178-10.582 2.603-3.688 6.27-4.637 12.186-5.385 1.495-.194 2.3-.855 2.775-1.869l6.707 15.636 6.873-15.887-.007.007Z",
    fill: "#fff"
  })), SeniorMandF_path7 || (SeniorMandF_path7 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.42 42.487c5.407.74 8.843 1.769 11.309 5.27 1.999 2.833 3.666 7.146 3.178 10.582a10.582 10.582 0 0 1-.36 1.625c-5.744 5.658-13.429 9.346-21.962 9.971a62.478 62.478 0 0 1-5.191 0c-8.533-.625-16.218-4.32-21.955-9.971a11.505 11.505 0 0 1-.36-1.625c-.489-3.436 1.18-7.75 3.178-10.582 2.494-3.537 5.967-4.55 11.46-5.291l6.361 20.64 3.904 6.844 3.746-6.722L45.42 42.48v.007Z",
    fill: "#00EEC8"
  })), SeniorMandF_path8 || (SeniorMandF_path8 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.094 66.226-.23-5.198c-.28-6.441-.15-6.298-.891 0l-.503 4.306c.532.31 1.07.604 1.624.885v.007Z",
    fill: "#AFC6D1"
  })), SeniorMandF_path9 || (SeniorMandF_path9 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m25.974 41.883 2.236-1.732 4.903 11.747-7.16-1.294.021-8.72Z",
    fill: "#A9E0F6"
  })), SeniorMandF_path10 || (SeniorMandF_path10 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m43.875 41.883-2.229-1.732-4.91 11.747 7.168-1.294-.029-8.72Z",
    fill: "#fff"
  })), SeniorMandF_path11 || (SeniorMandF_path11 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m27.017 51.826-4.63-1.704-2.545-6.815 6.269-1.424 8.871 28.067-9.856-16.097 1.89-2.027Z",
    fill: "#F7FCFE"
  })), SeniorMandF_path12 || (SeniorMandF_path12 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m42.97 51.826 4.629-1.704 2.538-6.815-6.262-1.424-8.871 28.067 9.856-16.097-1.89-2.027Z",
    fill: "#C8FBEE"
  })), SeniorMandF_path13 || (SeniorMandF_path13 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.855 60.626h8.562v5.83l-.093.05h-8.47v-5.88Z",
    fill: "#EDFEF9"
  })), SeniorMandF_path14 || (SeniorMandF_path14 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.413 61.258h1.445v1.625h1.625v1.416h-1.625v1.625h-1.445v-1.625H43.79v-1.416h1.624v-1.625Z",
    fill: "#118080"
  })), SeniorMandF_path15 || (SeniorMandF_path15 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m29.296 34.313 3.314.202c.798 0 1.589 0 2.38-.015v35.493c-.87 0-1.74-.022-2.603-.058-8.534-.625-16.219-4.313-21.956-9.97a11.507 11.507 0 0 1-.36-1.626c-.488-3.436 1.18-7.75 3.178-10.582 2.603-3.688 6.27-4.637 12.186-5.385 2.344-.294 3.005-1.768 3.3-3.918l.56-4.148v.008Z",
    fill: "#E5B085"
  })), SeniorMandF_path16 || (SeniorMandF_path16 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.996 69.993c-.87 0-1.74-.022-2.602-.05-8.533-.626-16.218-4.321-21.955-9.972a11.505 11.505 0 0 1-.36-1.624c-.489-3.437 1.18-7.75 3.178-10.583 2.602-3.688 6.269-4.637 12.185-5.385 1.495-.194 2.3-.855 2.775-1.869l6.708 15.637.079-.187V70l-.008-.007Z",
    fill: "#CCE1EC"
  })), SeniorMandF_path17 || (SeniorMandF_path17 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.996 69.993c-.87 0-1.74-.022-2.602-.05-8.533-.626-16.218-4.321-21.955-9.972a11.505 11.505 0 0 1-.36-1.624c-.489-3.437 1.18-7.75 3.178-10.583 2.494-3.537 5.967-4.55 11.46-5.291l6.361 20.64 3.904 6.844v-.022l.007.058h.008Z",
    fill: "#00CBAB"
  })), SeniorMandF_path18 || (SeniorMandF_path18 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.094 66.226-.23-5.198c-.28-6.441-.15-6.298-.891 0l-.503 4.306c.532.31 1.07.604 1.624.885v.007Z",
    fill: "#2F9291"
  })), SeniorMandF_path19 || (SeniorMandF_path19 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m25.974 41.883 2.236-1.732 4.903 11.747-7.16-1.294.021-8.72Z",
    fill: "#CCE1EC"
  })), SeniorMandF_path20 || (SeniorMandF_path20 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m27.017 51.826-4.63-1.704-2.545-6.815 6.269-1.424 8.871 28.067-9.856-16.097 1.89-2.027Z",
    fill: "#34F0CE"
  })), SeniorMandF_path21 || (SeniorMandF_path21 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.255 25.104c-.216-.273-.51-.388-.827-.402.057-.655.1-1.316.1-1.977.036-6.514-2.667-10.748-7.153-12.15a11 11 0 0 0-6.686.029c-4.42 1.423-7.232 5.622-7.232 12.12 0 .662.036 1.323.094 1.978-.31.021-.604.129-.82.402-.669.834-.374 2.631.28 3.911.238.467.525.87.95 1.172.287.208.61.345.848.237 1.179 3.235 3.084 5.967 5.5 7.577 2.882 1.927 4.615 1.898 7.483-.079 2.358-1.624 4.213-4.32 5.37-7.505.238.122.568-.022.87-.237.425-.302.712-.705.95-1.172.646-1.28.941-3.084.273-3.911v.007Z",
    fill: "#FBDEC2"
  })), SeniorMandF_path22 || (SeniorMandF_path22 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.996 10.072a10.86 10.86 0 0 0-3.307.532c-4.42 1.423-7.232 5.622-7.232 12.12 0 .662.036 1.323.094 1.978-.31.021-.604.129-.82.402-.669.834-.374 2.631.28 3.911.238.467.525.87.95 1.172.287.208.61.345.848.237 1.179 3.235 3.084 5.967 5.5 7.577 1.416.95 2.552 1.417 3.68 1.424v-29.36l.007.007Z",
    fill: "#E9C5A0"
  })), SeniorMandF_path23 || (SeniorMandF_path23 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.594 25.248a17.583 17.583 0 0 1-.913-5.579c0-5.866 3.012-9.662 7.764-10.942A14.03 14.03 0 0 1 38.62 8.7c4.816 1.265 7.72 5.09 7.678 10.97a17.954 17.954 0 0 1-.92 5.543c.021-.18.035-.36.057-.54-1.575-4.406-5.658-7.555-10.446-7.555-4.788 0-8.878 3.149-10.453 7.57.015.187.036.374.058.554v.007Zm20.884-1.078c.007-.151.022-.302.029-.453 0 .15-.015.302-.029.453Zm.036-.712c0-.122 0-.244.007-.367 0 .122 0 .245-.007.367Z",
    fill: "#EAEAEA"
  })), SeniorMandF_path24 || (SeniorMandF_path24 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.148 15.579h21.69c.187.747.33 1.553.438 2.365h-22.56c.101-.812.252-1.61.44-2.365h-.008Z",
    fill: "#565759"
  })), SeniorMandF_path25 || (SeniorMandF_path25 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.594 25.248a17.583 17.583 0 0 1-.913-5.579c0-5.866 3.012-9.662 7.764-10.941a13.775 13.775 0 0 1 3.551-.482v8.878c-4.788 0-8.878 3.15-10.453 7.57.015.187.036.374.058.554h-.007Z",
    fill: "#CBCCCC"
  })), SeniorMandF_path26 || (SeniorMandF_path26 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.148 15.579H34.99v2.365H23.71c.101-.812.252-1.61.44-2.365Z",
    fill: "#565759"
  })), SeniorMandF_path27 || (SeniorMandF_path27 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.78 11.416c2.977 0 5.392 2.444 5.392 5.464 0 3.02-2.415 5.464-5.391 5.464-2.977 0-5.392-2.452-5.392-5.464 0-3.012 2.415-5.464 5.392-5.464Z",
    fill: "#9A9CA0"
  })), SeniorMandF_path28 || (SeniorMandF_path28 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.78 11.416h.21v10.92h-.21c-2.976 0-5.391-2.451-5.391-5.463 0-3.013 2.415-5.464 5.392-5.464v.007Z",
    fill: "#848689"
  })), SeniorMandF_path29 || (SeniorMandF_path29 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.78 15.428c.791 0 1.438.654 1.438 1.46 0 .804-.647 1.458-1.437 1.458-.791 0-1.438-.654-1.438-1.459s.647-1.46 1.438-1.46Z",
    fill: "#393839"
  })), _path30 || (_path30 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.78 15.428c.073 0 .145 0 .21.014v2.883c-.073.007-.137.014-.21.014a1.447 1.447 0 0 1-1.437-1.46c0-.804.647-1.459 1.438-1.459v.008Z",
    fill: "#393839"
  })));
};
/* harmony default export */ var SeniorMandF = (SvgSeniorMandF);
;// CONCATENATED MODULE: ./modules/HomePageV2/staticData/testimonials.tsx




var testimonialData = [
    {
        text: "Great way to locum. The staff were very engaging and prepared for every little element of the locum placement. Attention to detail and professionalism was second to none.",
        svgIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SeniorMandF, {}),
        author: "Dr Andrew Thelander, ED Consultant"
    },
    {
        text: "You can choose when you want to work, how long you want to work for and then you can choose when you go back. It’s enabled me to have more time to spend with the family.",
        svgIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegistrarM, {}),
        author: "Dr Kevin Naidoo, General Surgeon"
    },
    {
        text: "Highly professional, responsive, supportive, knowledgeable.",
        svgIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegistrarF, {}),
        author: "Amy Boudreau, Clinical Director, Psychiatry"
    }, 
];

;// CONCATENATED MODULE: ./modules/HomePageV2/HomePageV2.tsx











var HomePageV2 = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (HomePageV2_module_default()).homePageV2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobSearchHeader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DigitalSolutionsSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobsSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonials, {
                testimonials: testimonialData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlacementTypeSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LifestyleSection, {
                headingLevel: "h2",
                doctorName: "Dr. Dave Homewood - Registrar"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyMedrecruit, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqSection, {})
        ]
    });
};
/* harmony default export */ var HomePageV2_HomePageV2 = (HomePageV2);

;// CONCATENATED MODULE: ./modules/HomePageV2/index.ts


// EXTERNAL MODULE: ./modules/CMSContainer/index.tsx
var CMSContainer = __webpack_require__(77439);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./pages/index.tsx







var HomePage = function(param) {
    var pageData = param.pageData;
    var defaultTitle = "Search over 2,000 Doctor Jobs in Australia and New Zealand.";
    var defaultDescription = "Discover the right doctor job for you in Australia or New Zealand";
    var track = (0,useAnalytics/* useAnalytics */.z)();
    (0,react.useEffect)(function() {
        track("Page View", {
            "Page Title": "Homepage",
            "Live experiments": []
        });
    }, [
        track
    ]);
    var _meta_title, _meta_description, _meta_title1, _meta_description1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CMSContainer/* default */.Z, {
        shouldUpdateFooterStyles: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                canonical: pageData.canonical_url,
                title: (_meta_title = pageData.meta_title) !== null && _meta_title !== void 0 ? _meta_title : defaultTitle,
                description: (_meta_description = pageData.meta_description) !== null && _meta_description !== void 0 ? _meta_description : defaultDescription,
                noindex: !pageData.index,
                nofollow: !pageData.index,
                openGraph: {
                    title: (_meta_title1 = pageData.meta_title) !== null && _meta_title1 !== void 0 ? _meta_title1 : defaultTitle,
                    description: (_meta_description1 = pageData.meta_description) !== null && _meta_description1 !== void 0 ? _meta_description1 : defaultDescription
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* FAQPageJsonLd */.Mg, {
                mainEntity: faqSeoSchemaData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageV2_HomePageV2, {})
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (HomePage);


/***/ }),

/***/ 2589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ searchLocation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var querystring__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17673);




var api = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    paramsSerializer: function(params) {
        return querystring__WEBPACK_IMPORTED_MODULE_1__.stringify(params);
    }
});
var searchLocation = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(term) {
        var response, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        api.get("/api/locations", {
                            params: {
                                q: term
                            }
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
                case 2:
                    error = _state.sent();
                    throw new Error("Failed to load locations", {
                        cause: error
                    });
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function searchLocation(term) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 73208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B5": function() { return /* binding */ getRadiusOptions; },
/* harmony export */   "HN": function() { return /* binding */ getSubSpecialityOptions; },
/* harmony export */   "J_": function() { return /* binding */ DEFAULT_RADIUS; },
/* harmony export */   "Lc": function() { return /* binding */ getSpecialityOptions; },
/* harmony export */   "Tu": function() { return /* binding */ getRootSpecialityOptions; },
/* harmony export */   "XG": function() { return /* binding */ MIN_PAY_RATES; },
/* harmony export */   "i$": function() { return /* binding */ DEFAULT_MIN_PAY_RATE_UNIT; },
/* harmony export */   "mG": function() { return /* binding */ getGradeOptions; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85639);


var DEFAULT_RADIUS = "50";
var DISTANCES = [
    "25",
    "50",
    "75",
    "100",
    "150"
];
var radiusOptions = DISTANCES.map(function(radius) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        value: radius,
        children: [
            radius,
            " km"
        ]
    }, radius);
});
var getRadiusOptions = function() {
    return radiusOptions;
};
var getGradeOptions = function(grades) {
    var options = [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            value: "none",
            "data-testid": "none",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                children: "None"
            })
        }, "none"), 
    ];
    if (grades) {
        grades.forEach(function(grade) {
            return grade && options.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                value: grade.value,
                "data-testid": grade.key,
                children: grade.value
            }, grade.key));
        });
    }
    return options;
};
var getSpecialityOptions = function(selectedGrade, specialities) {
    var ref;
    var options = [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            value: "none",
            "data-testid": "none",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                children: selectedGrade ? "None" : "Please select a grade"
            })
        }, "none"), 
    ];
    selectedGrade && specialities[selectedGrade] && ((ref = specialities[selectedGrade]) === null || ref === void 0 ? void 0 : ref.forEach(function(i) {
        return options.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            value: i.value,
            "data-testid": i.key,
            children: i.value
        }, i.key));
    }));
    return options;
};
var getRootSpecialityOptions = function(selectedGrade, specialities) {
    var ref;
    var options = [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            value: "none",
            "data-testid": "none",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                children: selectedGrade ? "None" : "Please select a grade"
            })
        }, "none"), 
    ];
    selectedGrade && specialities[selectedGrade] && ((ref = specialities[selectedGrade]) === null || ref === void 0 ? void 0 : ref.forEach(function(i) {
        return options.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            value: i.value,
            "data-testid": i.key,
            children: i.value
        }, i.key));
    }));
    return options;
};
var getSubSpecialityOptions = function(speciality, subSpecialities) {
    var ref;
    var options = [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            value: "none",
            "data-testid": "none",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                children: speciality ? "None" : "Please select a speciality"
            })
        }, "none"), 
    ];
    speciality && subSpecialities[speciality] && ((ref = subSpecialities[speciality]) === null || ref === void 0 ? void 0 : ref.forEach(function(i) {
        return options.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            value: i.value,
            "data-testid": i.key,
            children: i.value
        }, i.key));
    }));
    return options;
};
var DEFAULT_MIN_PAY_RATE_UNIT = "Hourly";
var MIN_PAY_RATES = {
    Hourly: [
        "75",
        "100",
        "125",
        "200",
        "250",
        "300"
    ],
    Daily: [
        "500",
        "600",
        "700",
        "800",
        "900",
        "1000",
        "1250",
        "1500",
        "1750",
        "2000",
        "2500",
        "3000", 
    ]
};


/***/ }),

/***/ 80059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dy": function() { return /* binding */ getGradeCookie; },
/* harmony export */   "Hl": function() { return /* binding */ setLocationCookie; },
/* harmony export */   "Jz": function() { return /* binding */ getLocationCookie; },
/* harmony export */   "Me": function() { return /* binding */ setSpecialityCookie; },
/* harmony export */   "nj": function() { return /* binding */ getSpecialityCookie; },
/* harmony export */   "r8": function() { return /* binding */ setGradeCookie; },
/* harmony export */   "yD": function() { return /* binding */ mapJobSearchLocationCookieToPreferredWorkLocation; }
/* harmony export */ });
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_0__);

var JOB_SEARCH_GRADE_COOKIE = "mr-job-search-grade";
var JOB_SEARCH_SPECIALITY_COOKIE = "mr-job-search-speciality";
var JOB_SEARCH_LOCATION_COOKIE = "mr-job-search-location";
var JOB_SEARCH_COOKIE_LIFE_IN_MS = 24 * 60 * 60 * 1000; // 24 hours
var getGradeCookie = function() {
    var value = (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.getCookie)(JOB_SEARCH_GRADE_COOKIE);
    if (value && typeof value === "string") {
        return value;
    }
    return null;
};
var setGradeCookie = function(grade) {
    (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.setCookie)(JOB_SEARCH_GRADE_COOKIE, grade, {
        expires: new Date(Date.now() + JOB_SEARCH_COOKIE_LIFE_IN_MS)
    });
};
var getSpecialityCookie = function() {
    var value = (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.getCookie)(JOB_SEARCH_SPECIALITY_COOKIE);
    if (value && typeof value === "string") {
        return value;
    }
    return null;
};
var setSpecialityCookie = function(speciality) {
    (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.setCookie)(JOB_SEARCH_SPECIALITY_COOKIE, speciality, {
        expires: new Date(Date.now() + JOB_SEARCH_COOKIE_LIFE_IN_MS)
    });
};
var getLocationCookie = function() {
    var value = (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.getCookie)(JOB_SEARCH_LOCATION_COOKIE);
    if (value && typeof value === "string") {
        var parsedValue;
        try {
            parsedValue = JSON.parse(value);
        } catch (_e) {
            return null;
        }
        if ((parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.name) && (parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.country)) {
            return {
                name: parsedValue.name,
                state: parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.state,
                country: parsedValue.country
            };
        }
    }
    return null;
};
var setLocationCookie = function(locationCoordinate) {
    var value = JSON.stringify({
        name: locationCoordinate.name,
        state: locationCoordinate === null || locationCoordinate === void 0 ? void 0 : locationCoordinate.state,
        country: locationCoordinate.country
    });
    (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.setCookie)(JOB_SEARCH_LOCATION_COOKIE, value, {
        expires: new Date(Date.now() + JOB_SEARCH_COOKIE_LIFE_IN_MS)
    });
};
var mapJobSearchLocationCookieToPreferredWorkLocation = function(locationCookie) {
    if (!locationCookie) {
        return null;
    }
    // country level
    if (locationCookie.name === "New Zealand") {
        return {
            key: "New Zealand",
            value: "Anywhere in New Zealand"
        };
    }
    if (locationCookie.name === "Australia") {
        return {
            key: "Australia",
            value: "Anywhere in Australia"
        };
    }
    // NZ locations
    if (locationCookie.country === "New Zealand") {
        if (locationCookie.name === "South Island") {
            return {
                key: "South Island of New Zealand",
                value: "South Island of New Zealand"
            };
        }
        if (locationCookie.name === "North Island") {
            return {
                key: "North Island of New Zealand",
                value: "North Island of New Zealand"
            };
        }
        return {
            key: "New Zealand",
            value: "Anywhere in New Zealand"
        };
    }
    // AU locations
    if (locationCookie.country === "Australia") {
        if (locationCookie.name === "Victoria" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Victoria") {
            return {
                key: "Victoria Australia",
                value: "Victoria Australia"
            };
        }
        if (locationCookie.name === "New South Wales" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "New South Wales") {
            return {
                key: "New South Wales Australia",
                value: "New South Wales Australia"
            };
        }
        if (locationCookie.name === "Queensland" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Queensland") {
            return {
                key: "Queensland Australia",
                value: "Queensland Australia"
            };
        }
        if (locationCookie.name === "South Australia" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "South Australia") {
            return {
                key: "South Australia",
                value: "South Australia"
            };
        }
        if (locationCookie.name === "Australian Capital Territory" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Australian Capital Territory") {
            return {
                key: "Australian Capital Territory",
                value: "Australian Capital Territory"
            };
        }
        if (locationCookie.name === "Tasmania" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Tasmania") {
            return {
                key: "Tasmania Australia",
                value: "Tasmania Australia"
            };
        }
        if (locationCookie.name === "Western Australia" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Western Australia") {
            return {
                key: "Western Australia",
                value: "Western Australia"
            };
        }
        if (locationCookie.name === "Northern Territory" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Northern Territory") {
            return {
                key: "Northern Territory Australia",
                value: "Northern Territory Australia"
            };
        }
    }
    return null;
};


/***/ }),

/***/ 58471:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__AUecm","accordionSummary":"Accordion_accordionSummary__SMdSK","secondary":"Accordion_secondary__lTdwm","accordionTitle":"Accordion_accordionTitle__4v7sK","icon":"Accordion_icon__R27Wo","accordion_top":"Accordion_accordion_top__shLGa","accordion_bottom":"Accordion_accordion_bottom__VaeYE","accordionDetails":"Accordion_accordionDetails__qSEDx"};

/***/ }),

/***/ 85474:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Button_container__wxGrQ","myButton":"Button_myButton__0wSRl","contained":"Button_contained__78t0q","secondary":"Button_secondary__X4hrj","outlined":"Button_outlined__09ghW"};

/***/ }),

/***/ 30606:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"EngagementButtons_container__H1vrF","button":"EngagementButtons_button__7_YrN","joinButton":"EngagementButtons_joinButton__LMhmH","searchButton":"EngagementButtons_searchButton__xAnRM"};

/***/ }),

/***/ 38948:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"ProfileBanner_bannerContainer__kQhdF","closed":"ProfileBanner_closed__qtWy_","imageContainer":"ProfileBanner_imageContainer__VFnDG","header":"ProfileBanner_header__oXcWU","subHeader":"ProfileBanner_subHeader__UqIrm","benefitsPillsList":"ProfileBanner_benefitsPillsList__YVD5X","closeButton":"ProfileBanner_closeButton__O17v8","getStartedButton":"ProfileBanner_getStartedButton__dMz_Q"};

/***/ }),

/***/ 64786:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"SectionContainer_sectionContainer__a7iNL"};

/***/ }),

/***/ 6705:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"TickList_container__Q0_9p","listItem":"TickList_listItem__KXl7I","checkIcon":"TickList_checkIcon__W2Bql","container_small":"TickList_container_small__k5lqe"};

/***/ }),

/***/ 26152:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"outsideContainer":"style_outsideContainer__TGLZO","footer":"style_footer__jNdIy","childrenContainer":"style_childrenContainer__ZS__i"};

/***/ }),

/***/ 64151:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"homePageV2":"HomePageV2_homePageV2__qcJfs"};

/***/ }),

/***/ 7981:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"DigitalSolutionsSection_container__U_cGk","sectionTitle":"DigitalSolutionsSection_sectionTitle__Vvs3o","itemsContainer":"DigitalSolutionsSection_itemsContainer__GIcBr","solutionItem":"DigitalSolutionsSection_solutionItem__Drf5M","solutionTitle":"DigitalSolutionsSection_solutionTitle__aTAGS","solutionText":"DigitalSolutionsSection_solutionText__fk2vl","registerButton":"DigitalSolutionsSection_registerButton__sRO54"};

/***/ }),

/***/ 1477:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"faqSectionContainer":"FaqSection_faqSectionContainer__iSn3w","faqSectionTitle":"FaqSection_faqSectionTitle__taxS1","faqTitle":"FaqSection_faqTitle__rilEa","faqSectionContent":"FaqSection_faqSectionContent__wWbdC"};

/***/ }),

/***/ 39778:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jobSearchHeaderContainer":"JobSearchHeader_jobSearchHeaderContainer__Z1eYx","leftTears":"JobSearchHeader_leftTears__HNWwL","rightTears":"JobSearchHeader_rightTears__SUNo4","title":"JobSearchHeader_title__LGyCC","jobSearchHeaderDropdown":"JobSearchHeader_jobSearchHeaderDropdown__8Lxri","searchForm":"JobSearchHeader_searchForm__KaBrW"};

/***/ }),

/***/ 76173:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"statsContainer":"MedrecruitStats_statsContainer__kzmhg","statsItem":"MedrecruitStats_statsItem__OH22X","statsHeader":"MedrecruitStats_statsHeader__WdyDr","statsSubText":"MedrecruitStats_statsSubText__Csrx9"};

/***/ }),

/***/ 39677:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gradeSelect":"GradeSelect_gradeSelect__wjx6X","label":"GradeSelect_label__xzIHF","selectButton":"GradeSelect_selectButton__pOPYx","selectText":"GradeSelect_selectText__dQtsn","arrow":"GradeSelect_arrow__ITFzS","dropdown":"GradeSelect_dropdown__F0eJt","dropdownSlideIn":"GradeSelect_dropdownSlideIn__NQjEC","option":"GradeSelect_option__IWPX3","optionButton":"GradeSelect_optionButton__L2a0u"};

/***/ }),

/***/ 16122:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"LocationAutoComplete_container__IBz0Z","Mui-focused":"LocationAutoComplete_Mui-focused__DaqC_","label":"LocationAutoComplete_label__zIWVp","option":"LocationAutoComplete_option__wPa2q","divider":"LocationAutoComplete_divider__w10YN","optionContent":"LocationAutoComplete_optionContent__yGrY2","locationName":"LocationAutoComplete_locationName__sEDCk","locationSubtitle":"LocationAutoComplete_locationSubtitle__FbJ0i","noOptions":"LocationAutoComplete_noOptions__TGUTZ"};

/***/ }),

/***/ 66514:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchButton_container__rZVGk","searchButton":"SearchButton_searchButton__dl4wK","spinner":"SearchButton_spinner__hD5Ro"};

/***/ }),

/***/ 73939:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"workTypeCheckboxGroup":"WorkTypeCheckboxGroup_workTypeCheckboxGroup__vgNh_","label":"WorkTypeCheckboxGroup_label__GFjRa","checkboxContainer":"WorkTypeCheckboxGroup_checkboxContainer__Z17gK","hiddenCheckbox":"WorkTypeCheckboxGroup_hiddenCheckbox__sZAwO","checkboxLabel":"WorkTypeCheckboxGroup_checkboxLabel___icih","labelText":"WorkTypeCheckboxGroup_labelText__JXvGs","customCheckbox":"WorkTypeCheckboxGroup_customCheckbox__KeCTE","checkIcon":"WorkTypeCheckboxGroup_checkIcon__kpvkg"};

/***/ }),

/***/ 46463:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jobButton":"JobCategoryButton_jobButton__6oZZS","jobButtonContent":"JobCategoryButton_jobButtonContent__ZjbbT","jobButtonTitle":"JobCategoryButton_jobButtonTitle__RHX_o","jobsPill":"JobCategoryButton_jobsPill__U_E1N","jobButtonImage":"JobCategoryButton_jobButtonImage__xAvmb","jobButtonImageWrapper":"JobCategoryButton_jobButtonImageWrapper__KJO2m"};

/***/ }),

/***/ 39761:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jobsSectionContainer":"JobsSection_jobsSectionContainer__iIxlH","jobsSectionTitle":"JobsSection_jobsSectionTitle__7TuK5","jobsGrid":"JobsSection_jobsGrid__Q0yEJ"};

/***/ }),

/***/ 13449:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lifestyleSection":"LifestyleSection_lifestyleSection__ZEP2e","imageContainer":"LifestyleSection_imageContainer__SsPyD","lifestyleImage":"LifestyleSection_lifestyleImage__tSmMa","drNamePill":"LifestyleSection_drNamePill__eWOR6","visible":"LifestyleSection_visible__ReTEH","contentContainer":"LifestyleSection_contentContainer__3CVeB","title":"LifestyleSection_title__MlDHj","description":"LifestyleSection_description__pDTEh","joinUsButton":"LifestyleSection_joinUsButton__weauV"};

/***/ }),

/***/ 97115:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"placementSectionContainer":"PlacementTypeSection_placementSectionContainer__9NQZh","sectionTitle":"PlacementTypeSection_sectionTitle__I_GAb","accordionTitle":"PlacementTypeSection_accordionTitle__xLC4C"};

/***/ }),

/***/ 1406:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"Content_contentContainer__YmeYy","contentText":"Content_contentText__GkRWN","contextText_width":"Content_contextText_width__WtJMN","imageContainer":"Content_imageContainer__eOZZz"};

/***/ }),

/***/ 21192:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"testimonialsContainer":"Testimonials_testimonialsContainer__Cfd_Y","testimonialContent":"Testimonials_testimonialContent__bl2yn","slideInFromRight":"Testimonials_slideInFromRight__8M1gx","slideOut":"Testimonials_slideOut__V78a7","slideOutToLeft":"Testimonials_slideOutToLeft__3L5W1","testimonialsText":"Testimonials_testimonialsText__CU8iW","longText":"Testimonials_longText__21NoQ","testimonialAuthorContainer":"Testimonials_testimonialAuthorContainer__6QJkF","testimonialAuthor":"Testimonials_testimonialAuthor__L6K9_","indicators":"Testimonials_indicators__LFyrj","indicator":"Testimonials_indicator__K7eNu","active":"Testimonials_active__m4RiK","progressFill":"Testimonials_progressFill__ipkk_","completed":"Testimonials_completed__UiJun","darkMode":"Testimonials_darkMode__Nbfiy"};

/***/ }),

/***/ 27621:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"whyMedrecruitContainer":"WhyMedrecruit_whyMedrecruitContainer__Ld1RN","whyJoinMedrecruitCards":"WhyMedrecruit_whyJoinMedrecruitCards__R0p4T","buttonContainer":"WhyMedrecruit_buttonContainer__lSzty"};

/***/ }),

/***/ 13546:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"whyJoinMedrecruitCard":"WhyJoinMedrecruitCard_whyJoinMedrecruitCard__pzWd9","description":"WhyJoinMedrecruitCard_description__o91MN","imageWrapper":"WhyJoinMedrecruitCard_imageWrapper__qxe_Z"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2491,5675,9669,4872,807,9803,9043,4485,3437,946,7979,2628,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);